import React, { useEffect, useState } from "react";
import { FaCheck, FaPlus, FaSave } from "react-icons/fa";
import { HiOutlineRefresh } from "react-icons/hi";
import { IoPrint } from "react-icons/io5";
import { LuView } from "react-icons/lu";
import { MdEdit } from "react-icons/md";
import { RiCloseLargeFill } from "react-icons/ri";
import A1 from "../Images/logo-w.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";

const PurchaseOrder = () => {
  const [selectedIndents, setSelectedIndents] = useState([]);
  const [selectedIndentss, setSelectedIndentss] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDataVisible, setIsDataVisible] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const id = user ? user.id : null;
  const userName = user ? user.User_nm : "Guest";
  const [suppliers, setSuppliers] = useState([]);
  const [Supp_id, setSelectedSupplier] = useState("");
  const [states, setStates] = useState({});
  const [Credit_days, setCreditDays] = useState("");
  const [stateMaster, setStateMaster] = useState({});
  const [Des_gst, setDesGst] = useState("");
  const [Des_state_cd, setDesState] = useState("");
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showEditformm, setShowEditFormm] = useState(false);
  const [showApproveForm, setShowApproveForm] = useState(false);
  const [PO_no, setPO_no] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [poData, setPoData] = useState(null);
  const [poNumbers, setPoNumbers] = useState([]);
  const [Po_Type, setPoType] = useState("CAPX");
  const [Deli_terms, setDeliTerms] = useState("");
  const [Freight_amt, setFreightAmt] = useState("");
  const [Insurance_amt, setInsuranceAmt] = useState("");
  const [Oth_amt, setOthAmt] = useState("");
  const [Item_type, setItemType] = useState("Local");
  const [currency, setCurrency] = useState("INR");
  const [Pay_terms, setPayTerms] = useState("");
  const [exchange_rate, setExchangeRate] = useState("");
  const [Total_amt, setTotal_Amt] = useState("");
  const [items, setItems] = useState("");
  const [Gross_amt, setGross_amt] = useState("");
  const [Disc_amt, setDisc_amt] = useState("");
  const [Taxable_amt, setTaxable_amt] = useState("");
  const [Net_amt, setNet_amt] = useState("");
  const [grpss_amt_fce, setGrossAmtFCE] = useState("");
  const [itemCosts, setItemCosts] = useState([]); // [{ indent_no, itemCd, itemCost }]


  const [round_amt, setRoundAmt] = useState("");


  console.log("This is Net_amt", Net_amt);

  useEffect(() => {
    if (Item_type === "Local") {
      setExchangeRate(""); // Clear exchange rate when Item_type is 'Local'
    }
  }, [Item_type]);

  const handleItemTypeChange = (e) => {
    const selectedType = e.target.value;
    setItemType(selectedType);

    // Force INR when Local is selected, otherwise default to USD
    setCurrency(selectedType === "Local" ? "INR" : "USD");
  };

  const fetchSuppliers = () => {
    axios
      .get("https://erpapi.emedha.in/pages/api/api/suppliers")
      .then((response) => {
        setSuppliers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching suppliers:", error);
      });
  };

  const fetchStateMaster = () => {
    axios
      .get("https://erpapi.emedha.in/pages/api/api/states")
      .then((response) => {
        setStates(response.data);
        setStateMaster(response.data);
      })
      .catch((error) => {
        console.error("Error fetching state master:", error);
      });
  };

  //   axios.get('https://erpapi.emedha.in/pages/api/api/items-indents')
  //     .then((response) => {
  //       //  setItems(response.data)

  //       // const filteredItems = response.data.filter(item => item.Flage === 1);
  //       const filteredItems = response.data.filter(item => item.Flage === 1 && item.PO_rais !== 1);

  //       setItems(filteredItems);
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching state master:', error);
  //     });
  // }, []);


  const fetchItems = () => {
    axios
      .get("https://erpapi.emedha.in/pages/api/api/items-indents")
      .then((response) => {
        const items = response.data; // Items from your 'items-indents' API

        // Fetch PO_DTL data from your local server
        axios
          .get("https://erpapi.emedha.in/pages/api/po_dtl")
          .then((poResponse) => {
            const poDtlData = poResponse.data; // PO_DTL data

            // Group PO_DTL data by Indent_no and Indent_loc and sum the PO_qty
            const groupedPO = poDtlData.reduce((acc, poItem) => {
              const key = `${poItem.Indent_no}-${poItem.Indent_loc}-${poItem.itemCd}`; // Create a unique key for each Indent_no & Indent_loc
              if (!acc[key]) {
                acc[key] = { totalPOQty: 0 }; // Initialize the accumulator for this group
              }
              acc[key].totalPOQty += poItem.PO_qty; // Sum the PO_qty for matching Indent_no and Indent_loc
              return acc;
            }, {});

            // Now we filter the items based on your conditions:
            const filteredItems = items
              .map((item) => {
                // Generate the key for current item
                if (item.Flage !== 1) {
                  return false;
                }
                const key = `${item.indent_no}-${item.Location_id}-${item.itemCd}`;

                // Check if there is matching PO_DTL data for the same Indent_no and Location_id
                const matchingPO = groupedPO[key];

                if (matchingPO) {
                  // Calculate the remaining quantity (Approved_qty - total PO_qty)
                  const remainingQty =
                    item.Approved_qty - matchingPO.totalPOQty;

                  // If the remaining quantity is 0 and PO_rais is 1, we exclude the item
                  if (remainingQty <= 0 && item.PO_rais === 1) {
                    return null; // Return null to exclude the item
                  }

                  // If the remaining quantity is greater than 0, we display that quantity
                  item.Remaining_qty = remainingQty > 0 ? remainingQty : 0;
                } else {
                  // If no matching PO_DTL, the Approved_qty is fully displayed
                  item.Remaining_qty = item.Approved_qty;
                }

                // Return the modified item (or null if we want to exclude)
                return item;
              })
              .filter((item) => item !== null); // Filter out the null values (excluded items)

            // Now, we have the filtered and calculated items
            setItems(filteredItems); // Assuming you have a state setter like `setItems`
          })
          .catch((error) => {
            console.error("Error fetching PO_DTL data:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching items:", error);
      });
  };

  useEffect(() => {
    fetchSuppliers(); // Fetch suppliers
    fetchStateMaster(); // Fetch state master
    fetchItems(); // Fetch items and calculate remaining quantity
  }, []);

  const handleSupplierChange = (event) => {
    const supplierCd = event.target.value;
    setSelectedSupplier(supplierCd);
    const selectedSupplierData = suppliers.find(
      (s) => s.Supp_cd.toString() === supplierCd.toString()
    );
    setCreditDays(selectedSupplierData ? selectedSupplierData.Credit_Days : "");
  };
  const handleSupplierChange1 = (selectedOption) => {
    const supplierCd = selectedOption ? selectedOption.value : "";
    setSelectedSupplier(supplierCd);
    const selectedSupplierData = suppliers.find(
      (s) => s.Supp_cd.toString() === supplierCd.toString()
    );
    setCreditDays(selectedSupplierData ? selectedSupplierData.Credit_Days : "");
  };

  const handleCreditDaysChange = (event) => {
    setCreditDays(event.target.value);
  };

  const supplier = suppliers.find(
    (s) => s.Supp_cd.toString() === Supp_id.toString()
  );

  const extractStateFromGST = (gst) => {
    if (!gst) return "";
    const stateCode = gst.substring(0, 2);
    const stateName = states[stateCode] || "Unknown State";
    return stateName;
  };

  const getStateName = (stateCode) => {
    if (stateMaster[stateCode]) {
      return stateMaster[stateCode]; // Return the corresponding state name
    }
    return stateCode; // If no match, return the state code itself
  };

  const handleDesGstChange = (e) => {
    const gstValue = e.target.value;
    if (gstValue.length <= 12) {
      setDesGst(gstValue);
      if (gstValue.length >= 2) {
        const stateCode = gstValue.substring(0, 2);
        const stateName = stateMaster[stateCode] || "Unknown State";
        setDesState(stateName);
      } else {
        setDesState("");
      }
    }
  };

  const [companyData, setCompanyData] = useState([]);

  const fetchCompanyData = async () => {
    try {
      const response = await axios.get(
        "https://erpapi.emedha.in/pages/api/api/get-Company-data"
      );
      setCompanyData(response.data); // Store company data
    } catch (err) {
      console.error("Error fetching company data");
    }
  };
  useEffect(() => {
    fetchCompanyData();
  }, []);

  useEffect(() => {
    if (companyData.length > 0) {
      // Set the first GST_NO value in the Des_gst state
      setDesGst(companyData[0].GST_NO);
    }
  }, [companyData]);

  useEffect(() => {
    if (Des_gst.length >= 2) {
      const stateCode = Des_gst.substring(0, 2);
      const stateName = stateMaster[stateCode] || "Unknown State";
      setDesState(stateName);
    }
  }, [Des_gst, stateMaster]);

  const [deliveryDate, setDeliveryDate] = useState("");
  const [PO_Dt, setPoDate] = useState("");

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setDeliveryDate(currentDate);
    setPoDate(currentDate);
  }, []);

  const [indents, setIndents] = useState([]);

  useEffect(() => {
    const fetchPendingIndents = async () => {
      try {
        const response = await fetch(
          "https://erpapi.emedha.in/pages/api/api/pending-indents"
        );

        const data = await response.json();

        setIndents(data);
      } catch (error) {
        console.error("Error fetching pending indents:", error);
      }
    };

    fetchPendingIndents();
  }, []);

  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    const fetchPONumbers = async () => {
      try {
        const response = await axios.get(
          "https://erpapi.emedha.in/pages/api/api/po-numbers"
        );
        setPoNumbers(response.data);
      } catch (err) {
        console.error("Error fetching PO numbers", err);
      }
    };
    fetchPONumbers();
  }, []);

  const latestPO = poNumbers.length > 0 ? Math.max(...poNumbers) : null;

  const handlePOSelectChangee = (selectedOption) => {
    if (selectedOption) {
      setPO_no(selectedOption.value);
    } else {
      setPO_no("");
    }
    setPoData(null);
    setIsEditing(false);
  };

  const poOptions = poNumbers.map((poNumber) => ({
    value: poNumber,
    label: poNumber,
  }));

  const handlePOSelectChangee1 = (selectedOption) => {
    if (selectedOption) {
      setPO_no(selectedOption.value);
    } else {
      setPO_no("");
    }
    setPoData(null);
    setIsEditing(false);
  };

  const poOptions1 = poNumbers.map((poNumber) => ({
    value: poNumber,
    label: poNumber,
  }));

  const netAmount = parseFloat(Net_amt) || 0;

  useEffect(() => {
    if (items.length > 0 && indents.length > 0) {
      const combined = indents
        .map((indent) => {
          const item = items.find(
            (item) =>
              // item.indent_no === indent.indent_no &&
              // item.Location_id === indent.location_id
              item.indent_no === indent.indent_no &&
              item.Location_id === indent.location_id &&
              item.itemCd === indent.itemCd
          );

          // Log to debug
          console.log(`Searching for indent_no: ${indent.indent_no} & Location_id: ${indent.location_id}`);
          console.log('Found item:', item);

          return {
            ...indent,
            itemDesc: item ? item.itemDesc : "N/A",
            itemUOM: item ? item.itemUOM : "N/A",
            Approved_qty: item ? item.Remaining_qty : "N/A",
            // Approved_qty: item ? item.Approved_qty : "N/A",
            Supp_Nm: item ? item.Supp_Nm : "N/A",
            Indent_dt: item ? item.Indent_dt : "N/A",
            all_remarks: item ? item.all_remarks : "N/A",
            Location_Desc: item ? item.Location_Desc : "N/A",
            taxRate: item ? item.taxRate : "N/A",
            hsnCode: item ? item.hsnCode : "N/A",
            qty: item ? item.qty : "N/A",
            Location_id: item ? item.Location_id : "N/A",
          };
        })
        .filter(
          (combinedItem) =>
            combinedItem.Indent_dt !== "N/A" &&
            combinedItem.Location_id !== "N/A"
        );

      console.log("Combined Data after update:", combined);
      setCombinedData(combined);
    }
  }, [items, indents]);

  //   useEffect(() => {
  //   if (items.length > 0 && indents.length > 0) {
  //     const combined = indents.map((indent) => {
  //       const item = items.find(
  //         (item) => item.indent_no === indent.indent_no
  //       );

  //       // Debug logs
  //       console.log(`Searching for indent_no: ${indent.indent_no}`);
  //       console.log("Found item:", item);

  //       return {
  //         ...indent,
  //         itemDesc: item ? item.itemDesc : "N/A",
  //         itemUOM: item ? item.itemUOM : "N/A",
  //         Approved_qty: item ? item.Remaining_qty : "N/A",
  //         Supp_Nm: item ? item.Supp_Nm : "N/A",
  //         Indent_dt: item ? item.Indent_dt : "N/A",
  //         all_remarks: item ? item.all_remarks : "N/A",
  //         Location_Desc: item ? item.Location_Desc : "N/A",
  //         taxRate: item ? item.taxRate : "N/A",
  //         hsnCode: item ? item.hsnCode : "N/A",
  //         qty: item ? item.qty : "N/A",
  //         Location_id: item ? item.Location_id : "N/A",
  //       };
  //     });

  //     console.log("Combined Data after update:", combined);
  //     setCombinedData(combined);
  //   }
  // }, [items, indents]);



  //   useEffect(() => {
  //   if (items.length > 0) {
  //     const combined = items.map((item) => ({
  //       ...item,
  //       itemDesc: item.itemDesc || "N/A",
  //       itemUOM: item.itemUOM || "N/A",
  //       Approved_qty: item.Remaining_qty || "N/A",
  //       Supp_Nm: item.Supp_Nm || "N/A",
  //       Indent_dt: item.Indent_dt || "N/A",
  //       all_remarks: item.all_remarks || "N/A",
  //       Location_Desc: item.Location_Desc || "N/A",
  //       taxRate: item.taxRate || "N/A",
  //       hsnCode: item.hsnCode || "N/A",
  //       qty: item.qty || "N/A",
  //       Location_id: item.Location_id || "N/A",
  //     }));

  //     console.log("Combined Data after update:", combined);
  //     setCombinedData(combined);
  //   }
  // }, [items]);




  console.log(items);
  console.log(indents);
  console.log('coombineddata', combinedData);

  const handleIndentSelection = (indent_no, index, itemCd) => {
    console.log("indent_no:", indent_no);
    console.log("Index:", index);
    console.log('ItemCode', itemCd);
    const key = `${indent_no}-${index}-${itemCd}`;
    setSelectedIndents((prev) => {
      if (prev.includes(key)) {
        return prev.filter((id) => id !== key);
      }
      return [...prev, key];
    });
  };

  const handleIndentAdd = () => {
    console.log("Selected Indents:", selectedIndents);
    setIsDataVisible(true);
    toggleModal();
  };

  const calculateGrossAmt = (poQty, itemRate) => {
    console.log(
      `Calculating Gross Amount with PO_qty: ${poQty}, Item_rate: ${itemRate}`
    );
    return poQty * itemRate;
  };

  const calculateDiscAmt = (grossAmt, discPerc) => {
    console.log(
      ` Calculating Discount Amount with Gross Amount: ${grossAmt}, Discount Percentage: ${discPerc}`
    );
    return (grossAmt * discPerc) / 100;
  };

  const calculateTaxableAmt = (grossAmt, discAmt) => {
    console.log(
      `Calculating Taxable Amount with Gross Amount: ${grossAmt}, Discount Amount: ${discAmt}`
    );
    return grossAmt - discAmt;
  };

  // const calculateTaxableAmt_FCE = (grossAmt, discAmt,exchange_rate) => {
  //   console.log(`Calculating Taxable Amount with Gross Amount: ${grossAmt}, Discount Amount: ${discAmt}`);
  //   return grossAmt - discAmt  * exchange_rate;
  // };
  // const calculateTaxableAmt_FCE = (grossAmt, discAmt, exchange_rate) => {
  //   console.log(`Calculating Taxable Amount with Gross Amount: ${grossAmt}, Discount Amount: ${discAmt}`);

  //   // First calculate the difference between grossAmt and discAmt
  //   const amountAfterDiscount = grossAmt - discAmt;

  //   // Then multiply that value by the exchange rate
  //   const taxableAmount = amountAfterDiscount * exchange_rate;

  //   // Return the final taxable amount
  //   return taxableAmount;
  // };

  const validateSupplierSelection = () => {
    if (!Supp_id) {
      alert("Please select a supplier before entering the PO quantity.");
      return false;
    }
    return true;
  };

  // Function to format values to two decimal places
  const formatDecimal = (value) => {
    if (value.includes(".")) {
      let parts = value.split(".");
      if (parts[1] && parts[1].length > 2) {
        return parts[0] + "." + parts[1].slice(0, 2);
      }
    }
    return value;
  };

  const handleInputChange = (e, indent_no, field, index, itemCd) => {
    console.log('this is handleInputChange', indent_no, index, itemCd)
    if (!Supp_id) {
      alert("Please select a supplier before entering the PO quantity.");
      return;
    }

    const value = e.target.value;
    console.log(value);
    setCombinedData((prevIndents) =>
      prevIndents.map((indent, i) => {
        console.log('this is prevIndents new', prevIndents)
        //indent.indent_no === indent_no  && indent.itemCd === itemCd

        if (Number(indent.indent_no) === Number(indent_no) &&
          Number(indent.itemCd) === Number(itemCd)) {
          const updatedIndent = { ...indent, [field]: value };
          console.log('this is updateInted', updatedIndent)
          const { cgstPer, sgstPer, igstPer } = calculateTaxes(
            indent.taxRate,
            Des_state_cd,
            extractStateFromGST(supplier.Gst_No)
          );
          updatedIndent.sgstPer = sgstPer;
          updatedIndent.cgstPer = cgstPer;
          updatedIndent.igstPer = igstPer;
          const grossAmt = calculateGrossAmt(updatedIndent.PO_qty, updatedIndent.Item_rate);
          console.log('this is pass poqty', updatedIndent.PO_qty);
          console.log('this is pass itemrate', updatedIndent.Item_rate);
          const discAmt = calculateDiscAmt(grossAmt, updatedIndent.Disc_per);
          const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
          updatedIndent.sgstAmt = (sgstPer * taxableAmt) / 100;
          updatedIndent.cgstAmt = (cgstPer * taxableAmt) / 100;
          updatedIndent.igstAmt = (igstPer * taxableAmt) / 100;

          return updatedIndent;
        }
        return indent;
      })
    );
  };

  // const handleInputChange = (e, indent_no, field, index) => {
  //   if (!validateSupplierSelection()) return;

  //   const value = formatDecimal(e.target.value); // format the value to two decimal places

  //   setCombinedData(prevIndents =>
  //     prevIndents.map((indent, i) => {
  //       if (indent.indent_no === indent_no && i === index) {
  //         const updatedIndent = { ...indent, [field]: value };

  //         // Recalculate taxes based on the updated data
  //         const { cgstPer, sgstPer, igstPer } = calculateTaxes(
  //           indent.taxRate,
  //           Des_state_cd,
  //           extractStateFromGST(supplier.Gst_No)
  //         );
  //         updatedIndent.sgstPer = sgstPer;
  //         updatedIndent.cgstPer = cgstPer;
  //         updatedIndent.igstPer = igstPer;

  //         // Recalculate amounts based on the updated fields
  //         const grossAmt = calculateGrossAmt(updatedIndent.PO_qty, updatedIndent.Item_rate);
  //         const discAmt = calculateDiscAmt(grossAmt, updatedIndent.Disc_per);
  //         const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);

  //         updatedIndent.sgstAmt = (sgstPer * taxableAmt) / 100;
  //         updatedIndent.cgstAmt = (cgstPer * taxableAmt) / 100;
  //         updatedIndent.igstAmt = (igstPer * taxableAmt) / 100;

  //         return updatedIndent;
  //       }
  //       return indent;
  //     })
  //   );
  // };

  const calculateTaxes = (gstPer, desStateCd, suppStateCd) => {
    let cgstPer = 0;
    let sgstPer = 0;
    let igstPer = 0;
    if (gstPer === undefined || gstPer === null || isNaN(gstPer)) {
      return { cgstPer, sgstPer, igstPer };
    }
    if (desStateCd === suppStateCd) {
      cgstPer = gstPer / 2;
      sgstPer = gstPer / 2;
    } else {
      igstPer = gstPer;
    }
    return { cgstPer, sgstPer, igstPer };
  };

  console.log(selectedIndents);

  // const calculateTotalAmountAndDetails = () => {
  //   console.log("Selected Indents Data:", selectedIndents);

  //   const grossAmt = combinedData
  //     .filter((indent, index) => selectedIndents.includes(`${indent.indent_no}-${index}`))
  //     .reduce((sum, indent) => {
  //       console.log("Processing indent:", indent);

  //       const qty = parseFloat(indent.PO_qty);
  //       const rate = parseFloat(indent.Item_rate);
  //       const itemGrossAmt = calculateGrossAmt(qty, rate);
  //       return sum + itemGrossAmt;
  //     }, 0);
  //   console.log("Gross Amount:", grossAmt);
  //   const discAmt = combinedData
  //     .filter((indent, index) => selectedIndents.includes(`${indent.indent_no}-${index}`))
  //     .reduce((sum, indent) => {
  //       const grossAmt = calculateGrossAmt(parseFloat(indent.PO_qty), parseFloat(indent.Item_rate));
  //       const itemDiscAmt = calculateDiscAmt(grossAmt, parseFloat(indent.Disc_per));
  //       return sum + itemDiscAmt;
  //     }, 0);
  //   console.log("Discount Amount:", discAmt);

  //   const taxableAmt = combinedData
  //     .filter((indent, index) => selectedIndents.includes(`${indent.indent_no}-${index}`))
  //     .reduce((sum, indent) => {
  //       const grossAmt = calculateGrossAmt(parseFloat(indent.PO_qty), parseFloat(indent.Item_rate));
  //       const discAmt = calculateDiscAmt(grossAmt, parseFloat(indent.Disc_per));
  //       const itemTaxableAmt = calculateTaxableAmt(grossAmt, discAmt);
  //       return sum + itemTaxableAmt;
  //     }, 0);
  //   console.log("Taxable Amount:", taxableAmt);

  //   const Net_amt = combinedData.filter((indent, index) => { const key = `${indent.indent_no}-${index}`; return selectedIndents.includes(key); }).reduce((sum, indent) => {
  //     const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
  //     const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
  //     const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
  //     const sgstAmt = (parseFloat(indent.sgstPer) * taxableAmt) / 100;
  //     const cgstAmt = (parseFloat(indent.cgstPer) * taxableAmt) / 100;
  //     const igstAmt = (parseFloat(indent.igstPer) * taxableAmt) / 100;
  //     return sum + (taxableAmt + sgstAmt + cgstAmt + igstAmt);
  //   }, 0);

  //   const Net_ammt = Math.round(Net_amt * 100) / 100;
  //   console.log("Net Amount:", Net_ammt);
  //   console.log(Net_amt)
  //   const Total_amt = Net_ammt + parseFloat(Freight_amt || 0) + parseFloat(Insurance_amt || 0) + parseFloat(Oth_amt || 0);

  //   setTotal_Amt(Total_amt);
  //   console.log("Total Amount:", Total_amt);

  //   return { grossAmt, discAmt, taxableAmt, Net_amt, Total_amt };
  // };

  const calculateTotalAmountAndDetails = () => {
    console.log("Selected Indents Data:", selectedIndents);

    const grossAmt = combinedData
      .filter((indent, index) =>
        selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)
      )
      .reduce((sum, indent) => {
        console.log("Processing indent:", indent);

        const qty = parseFloat(indent.PO_qty);
        const rate = parseFloat(indent.Item_rate);
        const itemGrossAmt = calculateGrossAmt(qty, rate);
        return sum + itemGrossAmt;
      }, 0);
    console.log("Gross Amount:", grossAmt);

    const discAmt = combinedData
      .filter((indent, index) =>
        selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)
      )
      .reduce((sum, indent) => {
        const grossAmt = calculateGrossAmt(
          parseFloat(indent.PO_qty),
          parseFloat(indent.Item_rate)
        );
        const itemDiscAmt = calculateDiscAmt(
          grossAmt,
          parseFloat(indent.Disc_per)
        );
        return sum + itemDiscAmt;
      }, 0);
    console.log("Discount Amount:", discAmt);

    const taxableAmt = combinedData
      .filter((indent, index) =>
        selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)
      )
      .reduce((sum, indent) => {
        const grossAmt = calculateGrossAmt(
          parseFloat(indent.PO_qty),
          parseFloat(indent.Item_rate)
        );
        const discAmt = calculateDiscAmt(grossAmt, parseFloat(indent.Disc_per));
        const itemTaxableAmt = calculateTaxableAmt(grossAmt, discAmt);
        return sum + itemTaxableAmt;
      }, 0);
    console.log("Taxable Amount:", taxableAmt);

    let Net_amt = 0;

    if (Item_type === "Local") {
      // Logic for 'Local'
      Net_amt = combinedData
        .filter((indent, index) => {
          const key = `${indent.indent_no}-${index}-${indent.itemCd}`;
          return selectedIndents.includes(key);
        })
        .reduce((sum, indent) => {
          const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
          const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
          const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
          const sgstAmt = (parseFloat(indent.sgstPer) * taxableAmt) / 100;
          const cgstAmt = (parseFloat(indent.cgstPer) * taxableAmt) / 100;
          const igstAmt = (parseFloat(indent.igstPer) * taxableAmt) / 100;
          return sum + (taxableAmt + sgstAmt + cgstAmt + igstAmt);
        }, 0);
    } else if (Item_type === "Import") {
      // Logic for 'Import'
      Net_amt = combinedData
        .filter((indent, index) => {
          const key = `${indent.indent_no}-${index}-${indent.itemCd}`;
          return selectedIndents.includes(key);
        })
        .reduce((sum, indent) => {
          const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
          const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
          const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
          return sum + taxableAmt * exchange_rate;
        }, 0);
    }

    const Net_ammt = Math.round(Net_amt * 100) / 100;
    console.log("Net Amount:", Net_ammt);
    console.log(Net_amt);

    const Total_amt =
      Net_ammt +
      parseFloat(Freight_amt || 0) +
      parseFloat(Insurance_amt || 0) +
      parseFloat(Oth_amt || 0) +
      parseFloat(round_amt || 0);

    setTotal_Amt(Total_amt);
    console.log("Total Amount:", Total_amt);

    return { grossAmt, discAmt, taxableAmt, Net_amt, Total_amt };
  };


  const handleSave = async () => {
    console.log("Save button clicked");
    console.log("isediting", isEditing);

    console.log("Selected Indents:", selectedIndents);
    // if (selectedIndents.length === 0) {
    //   alert('No indent selected for the purchase order.');

    //   return;
    // }
    const missingFields = [];
    combinedData.forEach((indent, index) => {
      if (selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)) {
        if (!indent.PO_qty || !indent.Item_rate || !indent.Disc_per) {
          missingFields.push(`Indent No: ${indent.indent_no}`);
        }
      }
    });
    if (missingFields.length > 0) {
      return;
    }
    if (latestPO !== null) {
      alert(`PO Number id: ${latestPO + 1}`);
    }

    const { grossAmt, discAmt, taxableAmt, Net_amt, Total_amt } =
      calculateTotalAmountAndDetails();
    const poHeaderData = {
      PO_Dt: PO_Dt,
      Po_Type: Po_Type,
      Item_type: Item_type,
      Deli_terms: Deli_terms,
      Deli_dt: deliveryDate,
      Pay_terms: Pay_terms,
      currency: currency,
      exchange_rate: exchange_rate,
      Credit_days: Credit_days,
      Des_gst: Des_gst || "",
      Des_state_cd: Des_gst ? Des_gst.slice(0, 2) : "",
      Supp_id: Supp_id,
      Supp_gst:
        suppliers.find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No || "",
      Supp_state_cd:
        suppliers
          .find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No.slice(0, 2) || "",
      Gross_amt: grossAmt,
      Disc_amt: discAmt,
      Taxable_amt: taxableAmt,
      Net_amt: Net_amt,
      Freight_amt: Freight_amt,
      Insurance_amt: Insurance_amt,
      Oth_amt: Oth_amt,
      round_amt: round_amt,
      Total_amt: Total_amt,
    };


    console.log('this is poHeaderData 3308', poHeaderData)
    console.log(combinedData);

    const poDtlData = combinedData

      .filter((indent, index) =>
        selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)
      )
      .map((indent, index) => {
        const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
        const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
        const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
        const supplier = suppliers.find(
          (s) => s.Supp_cd.toString() === Supp_id.toString()
        );
        const supplierGstNo = supplier?.Gst_No || "";
        const { cgstPer, sgstPer, igstPer } = calculateTaxes(
          indent.taxRate,
          Des_state_cd,
          extractStateFromGST(supplierGstNo)
        );
        // ✅ Find matching item cost from state
        // const foundCost = itemCosts.find(
        //   (c) => c.indent_no === indent.Indent_no && c.itemCd === indent.itemCd
        // );
        // const Item_cost = foundCost ? foundCost.itemCost : 0;
        // ✅ Fix: use correct field name (indent_no)
        console.log("Current itemCosts before save:", itemCosts);
        console.log('this is indent 3333', indent)
        const foundCost = itemCosts.find(
          (c) => c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
        );
        const Item_cost = foundCost ? foundCost.itemCost : 0;
        const Actual_Rate =
          (parseFloat(indent.Item_rate) || 0) + (parseFloat(Item_cost) || 0);

        return {
          Sl_no: indent.Sl_no,
          itemCd: indent.itemCd,
          itemDesc: indent.itemDesc,
          UOM: indent.itemUOM,
          Hsn_code: indent.hsnCode,
          GST_per: indent.taxRate,
          Indent_loc: indent.Location_id,
          Indent_no: indent.indent_no,
          qty: indent.qty,
          PO_qty: indent.PO_qty,
          Item_rate: indent.Item_rate,
          Gross_amt: grossAmt,
          PO_DTL_Disc_per: indent.Disc_per,
          Disc_amt: discAmt,
          Taxable_amt: taxableAmt,
          grpss_amt_fce: taxableAmt * exchange_rate,
          Sgst_per: sgstPer,
          Sgst_amt: (sgstPer * taxableAmt) / 100,
          Cgst_per: cgstPer,
          Cgst_amt: (cgstPer * taxableAmt) / 100,
          Igst_per: igstPer,
          Igst_amt: (igstPer * taxableAmt) / 100,
          Ugst_per: 0,
          Ugst_amt: 0,
          Net_amt: (
            calculateTaxableAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              calculateDiscAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                indent.Disc_per
              )
            ) +
            indent.sgstAmt +
            indent.cgstAmt +
            indent.igstAmt
          ).toFixed(2),
          Item_cost: Item_cost,
          Actual_Rate: Actual_Rate,
        };
      });

    console.log(visibleRows);


    const totalNetAmtt = visibleRows?.reduce((sum, item) => {
      const isImport = item?.Item_type?.toLowerCase() === "import";
      const net = parseFloat(isImport ? item?.grpss_amt_fce : item?.Net_amt) || 0;
      return sum + net;
    }, 0);

    const poHeaderData1 = {
      PO_Dt: PO_Dt,
      Po_Type: Po_Type,
      Item_type: Item_type,
      Deli_terms: Deli_terms,
      Deli_dt: deliveryDate,
      Pay_terms: Pay_terms,
      Credit_days: Credit_days,
      Des_gst: Des_gst || "",
      Des_state_cd: Des_gst ? Des_gst.slice(0, 2) : "",
      Supp_id: Supp_id,
      Supp_gst:
        suppliers.find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No || "",
      Supp_state_cd:
        suppliers
          .find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No.slice(0, 2) || "",

      Gross_amt: Gross_amt,
      Disc_amt: Disc_amt,
      Taxable_amt: Taxable_amt,
      // Net_amt: Net_amt, 
      Net_amt: totalNetAmtt,

      Freight_amt: Freight_amt,
      Insurance_amt: Insurance_amt,
      Oth_amt: Oth_amt,
      round_amt: round_amt,
      Total_amt: Total_amt,
    };


    console.log('this is poHeaderData1 3418', poHeaderData1)

    const totalAdditionalCharges =
      Number(poHeaderData1.Freight_amt || 0) +
      Number(poHeaderData1.Insurance_amt || 0) +
      Number(poHeaderData1.Oth_amt || 0);

    console.log("visibleRows:", visibleRows);
    console.log("SelectedIndentsss:", SelectedIndentsss);

    const selectedRows = visibleRows.filter((indent, index) => {
      const indentKey = indent.Indent_no
        ? `${indent.Indent_no}-${index}-${indent.itemCd}`
        : null;
      return indentKey && SelectedIndentsss.includes(indentKey);
    });

    // Sum of Net_amt from all selected rows
    const totalRowNetAmt = selectedRows.reduce(
      (sum, indent) => sum + parseFloat(indent.Net_amt || 0),
      0
    );


    const poDtlData1 = visibleRows
      .filter((indent, index) => {
        // Ensure indent_no exists and check against SelectedIndentsss
        const indentKey = indent.Indent_no
          ? `${indent.Indent_no}-${index}-${indent.itemCd}`
          : null;
        return indentKey && SelectedIndentsss.includes(indentKey);
      })
      //.filter((indent) => SelectedIndentsss.includes(`${indent.indent_no}-${indent.itemCd}`))
      .map((indent, index) => {
        const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
        const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
        const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
        const supplier = suppliers.find(
          (s) => s.Supp_cd.toString() === Supp_id.toString()
        );
        const supplierGstNo = supplier?.Gst_No || "";
        //  const { cgstPer, sgstPer, igstPer } = calculateTaxes(indent.taxRate, Des_state_cd, extractStateFromGST(supplierGstNo));
        const Net_amt = (
          calculateTaxableAmt(
            calculateGrossAmt(indent.PO_qty, indent.Item_rate),
            calculateDiscAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              indent.Disc_per
            )
          ) +
          indent.SgstAmt +
          indent.CgstAmt +
          indent.IgstAmt
        ).toFixed(2);

        // Header-level additional charges
        //  const Item_cost =
        // poHeaderData1.Net_amt && parseFloat(poHeaderData1.Net_amt) !== 0
        //   ? (totalAdditionalCharges * parseFloat(indent.Net_amt)) / parseFloat(poHeaderData1.Net_amt)
        //   : 0;
        const Item_cost =
          totalRowNetAmt !== 0
            ? (totalAdditionalCharges * parseFloat(indent.Net_amt)) / totalRowNetAmt
            : 0;

        // ✅ Calculate Actual Rate (Item_rate + Item_cost)
        const Actual_Rate =
          (parseFloat(indent.Item_rate) || 0) + (parseFloat(Item_cost) || 0);


        return {
          Sl_no: indent.Sl_no,
          itemCd: indent.itemCd,
          itemDesc: indent.itemDesc,
          UOM: indent.UOM,
          Hsn_code: indent.Hsn_code,
          GST_per: indent.GST_per,
          Indent_loc: indent.Indent_loc,
          Indent_no: indent.Indent_no,
          qty: indent.qty,
          PO_qty: indent.PO_qty,
          Item_rate: indent.Item_rate,
          Gross_amt: indent.Gross_amt,
          Disc_per: indent.Disc_per,
          Disc_amt: indent.Disc_amt,
          Taxable_amt: indent.Taxable_amt,
          Sgst_per: indent.Sgst_per,
          Sgst_amt: (indent.Sgst_per * indent.Taxable_amt) / 100,
          Cgst_per: indent.Cgst_per,
          Cgst_amt: (indent.Cgst_per * indent.Taxable_amt) / 100,
          Igst_per: indent.Igst_per,
          Igst_amt: (indent.Igst_per * indent.Taxable_amt) / 100,
          Ugst_per: 0,
          Ugst_amt: 0,
          Net_amt: indent.Net_amt,
          // Item_cost: Item_cost, 
          Item_cost: Item_cost.toFixed(2),

          Actual_Rate: Actual_Rate.toFixed(2),
        };
      });

    const requestData = { PO_HDR: poHeaderData, PO_DTL: poDtlData };

    //console.log("PO Header Data:", poHeaderData);
    //console.log("PO Detail Data:", poDtlData);

    // const totalNetAmt = poDtlData1.reduce((sum, item) => sum + parseFloat(item.Net_amt), 0);
    //  const totalAmt = totalNetAmt + poHeaderData.Freight_amt + poHeaderData.Insurance_amt + poHeaderData.Oth_amt;

    // const requestData1 = { PO_HDR: poHeaderData, PO_DTL: poDtlData1,Total_amt: totalAmt.toFixed(2) }



    // const totalNetAmt = poDtlData1.reduce(
    //   (sum, item) => sum + parseFloat(item.Net_amt),
    //   0
    // );
    // const totalAmt =
    //   totalNetAmtt +
    //   poHeaderData.Freight_amt +
    //   poHeaderData.Insurance_amt +
    //   poHeaderData.Oth_amt +
    //   poHeaderData.round_amt;

    // Ensure totalAmt is a valid number before using toFixed
    // const formattedTotalAmt = isNaN(totalAmt) ? 0 : totalAmt; // Default to 0 if NaN
    // const requestData1 = {
    //   PO_HDR: poHeaderData1,
    //   PO_DTL: poDtlData1,
    //   Total_amt: formattedTotalAmt.toFixed(2),
    // };



    // from approve 
    const totalAdditionalCharges1 =
      Number(poHeaderData1.Freight_amt || 0) +
      Number(poHeaderData1.Insurance_amt || 0) +
      Number(poHeaderData1.Oth_amt || 0) +
      Number(poHeaderData1.round_amt || 0);

    // ✅ Calculate Net total from DTL
    const totalNetAmt = poDtlData1.reduce(
      (sum, item) => sum + Number(item.Net_amt || 0),
      0
    );
    console.log("✅ totalNetAmt:", totalNetAmt);

    // ✅ Compute Total Amount safely
    const totalAmt = totalNetAmt + totalAdditionalCharges1;

    // ✅ Assign properly to PO Header
    poHeaderData1.Net_amt = totalNetAmt.toFixed(2);
    poHeaderData1.Total_amt = isNaN(totalAmt)
      ? "0.00"
      : totalAmt.toFixed(2);

    // ✅ Final request data
    const requestData1 = {
      PO_HDR: poHeaderData1,
      PO_DTL: poDtlData1,
      Total_amt: poHeaderData1.Total_amt,
    };


    console.log("PO_no:", PO_no);
    //console.log("Request Data:", requestData);

    console.log("Request Data1:", requestData1);


    console.log("PO Header Data:", poHeaderData1);
    console.log("PO Detail Data:", poDtlData1);

    const resetForm = () => {
      setSelectedIndents([]);
      setVisibleRows([]);
      // Reset other relevant states like Freight_amt, Insurance_amt, Oth_amt, etc.
    };

    if (isEditing) {
      try {
        console.log("buttonClick");
        await axios.put(
          `https://erpapi.emedha.in/pages/api/API/PURCHASE_ORDER/${PO_no}`,
          requestData1
        );
        alert("Purchase Order updated successfully!");
        window.location.reload();
        resetForm();
      } catch (error) {
        alert("Failed to update purchase order. Please try again.");
      }
    } else {
      try {
        const response = await axios.post(
          "https://erpapi.emedha.in/pages/api/PURCHASE_ORDER",
          requestData
        );
        console.log("Response from backend:", response);
        alert("Purchase Order added successfully!");

        fetchSuppliers(); // Fetch suppliers
        fetchStateMaster(); // Fetch state master
        fetchItems();
        setCombinedData();
        fetchPOData();
        resetForm();
        window.location.reload();
      } catch (error) {
        console.error("Error adding indent:", error);
        alert("Failed to add purchase order. Please try again.");
      }
    }
  };

  const handleApprove = async () => {
    console.log("Save button clicked");

    console.log("Selected Indents:", selectedIndents);

    const missingFields = [];
    combinedData.forEach((indent, index) => {
      if (selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)) {
        if (!indent.PO_qty || !indent.Item_rate || !indent.Disc_per) {
          missingFields.push(`Indent No: ${indent.indent_no}`);
        }
      }
    });
    if (missingFields.length > 0) {
      alert(`Missing fields for: ${missingFields.join(", ")}`);
      return;
    }

    if (latestPO !== null) {
      alert(`PO Number id: ${latestPO + 1}`);
    }

    const { grossAmt, discAmt, taxableAmt, Net_amt, Total_amt } =
      calculateTotalAmountAndDetails();
    const poHeaderData = {
      PO_Dt: PO_Dt,
      Po_Type: Po_Type,
      Item_type: Item_type,
      Deli_terms: Deli_terms,
      Deli_dt: deliveryDate,
      Pay_terms: Pay_terms,
      Credit_days: Credit_days,
      Des_gst: Des_gst || "",
      Des_state_cd: Des_gst ? Des_gst.slice(0, 2) : "",
      Supp_id: Supp_id,
      Supp_gst:
        suppliers.find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No || "",
      Supp_state_cd:
        suppliers
          .find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No.slice(0, 2) || "",
      Gross_amt: grossAmt,
      Disc_amt: discAmt,
      Taxable_amt: taxableAmt,
      Net_amt: Net_amt,
      Freight_amt: Freight_amt,
      Insurance_amt: Insurance_amt,
      Oth_amt: Oth_amt,
      Total_amt: Total_amt,
    };

    const poDtlData = combinedData
      .filter((indent, index) =>
        selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`)
      )
      .map((indent) => {
        const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
        const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
        const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
        const supplier = suppliers.find(
          (s) => s.Supp_cd.toString() === Supp_id.toString()
        );
        const supplierGstNo = supplier?.Gst_No || "";
        const { cgstPer, sgstPer, igstPer } = calculateTaxes(
          indent.taxRate,
          Des_state_cd,
          extractStateFromGST(supplierGstNo)
        );

        console.log("Current itemCosts before save:", itemCosts);
        console.log('this is indent 3333', indent)

        const foundCost = itemCosts.find(
          (c) => c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
        );
        const Item_cost = foundCost ? foundCost.itemCost : 0;



        return {
          Sl_no: indent.Sl_no,
          itemCd: indent.itemCd,
          itemDesc: indent.itemDesc,
          UOM: indent.itemUOM,
          Hsn_code: indent.hsnCode,
          GST_per: indent.taxRate,
          Indent_loc: indent.Location_id,
          Indent_no: indent.indent_no,
          qty: indent.qty,
          PO_qty: indent.PO_qty,
          Item_rate: indent.Item_rate,
          Gross_amt: grossAmt,
          PO_DTL_Disc_per: indent.Disc_per,
          Disc_amt: discAmt,
          Taxable_amt: taxableAmt,
          Sgst_per: sgstPer,
          Sgst_amt: (sgstPer * taxableAmt) / 100,
          Cgst_per: cgstPer,
          Cgst_amt: (cgstPer * taxableAmt) / 100,
          Igst_per: igstPer,
          Igst_amt: (igstPer * taxableAmt) / 100,
          Ugst_per: 0,
          Ugst_amt: 0,
          Net_amt: (
            calculateTaxableAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              calculateDiscAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                indent.Disc_per
              )
            ) +
            indent.sgstAmt +
            indent.cgstAmt +
            indent.igstAmt
          ).toFixed(2),
          Item_cost: Item_cost,
        };
      });

    console.log(visibleRows);

    const poHeaderData1 = {
      PO_Dt: PO_Dt,
      Po_Type: Po_Type,
      Item_type: Item_type,
      Deli_terms: Deli_terms,
      Deli_dt: deliveryDate,
      Pay_terms: Pay_terms,
      Credit_days: Credit_days,
      Des_gst: Des_gst || "",
      Des_state_cd: Des_gst ? Des_gst.slice(0, 2) : "",
      Supp_id: Supp_id,
      Supp_gst:
        suppliers.find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No || "",
      Supp_state_cd:
        suppliers
          .find((s) => s.Supp_cd.toString() === Supp_id.toString())
          ?.Gst_No.slice(0, 2) || "",
      Gross_amt: Gross_amt,
      Disc_amt: Disc_amt,
      Taxable_amt: Taxable_amt,
      Net_amt: Net_amt,
      Freight_amt: Freight_amt,
      Insurance_amt: Insurance_amt,
      Oth_amt: Oth_amt,
      round_amt: round_amt,
      Total_amt: 0,
    };

    const totalAdditionalCharges =
      Number(poHeaderData1.Freight_amt || 0) +
      Number(poHeaderData1.Insurance_amt || 0) +
      Number(poHeaderData1.Oth_amt || 0);


    console.log("visibleRows", visibleRows);
    console.log("SelectedIndentsss", SelectedIndentsss);


    const selectedRows = visibleRows.filter((indent, index) => {
      const indentKey = indent.Indent_no
        ? `${indent.Indent_no}-${index}-${indent.itemCd}`
        : null;
      return indentKey && SelectedIndentsss.includes(indentKey);
    });

    // Sum of Net_amt from all selected rows
    const totalRowNetAmt = selectedRows.reduce(
      (sum, indent) => sum + parseFloat(indent.Net_amt || 0),
      0
    );


    const poDtlData1 = visibleRows
      .filter((indent, index) => {
        const indentKey = indent.Indent_no
          ? `${indent.Indent_no}-${index}-${indent.itemCd}`
          : null;
        return indentKey && SelectedIndentsss.includes(indentKey);
      })
      .map((indent, index) => {
        const grossAmt = calculateGrossAmt(indent.PO_qty, indent.Item_rate);
        const discAmt = calculateDiscAmt(grossAmt, indent.Disc_per);
        const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
        const supplier = suppliers.find(
          (s) => s.Supp_cd.toString() === Supp_id.toString()
        );
        const supplierGstNo = supplier?.Gst_No || "";
        const Net_amt = (
          calculateTaxableAmt(
            calculateGrossAmt(indent.PO_qty, indent.Item_rate),
            calculateDiscAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              indent.Disc_per
            )
          ) +
          indent.SgstAmt +
          indent.CgstAmt +
          indent.IgstAmt
        ).toFixed(2);

        const Item_cost =
          totalRowNetAmt !== 0
            ? (totalAdditionalCharges * parseFloat(indent.Net_amt)) / totalRowNetAmt
            : 0;
        // const foundCost = itemCosts.find(
        //   (c) => c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
        // );
        // const Item_cost = foundCost ? foundCost.itemCost : 0;


        // ✅ Calculate Actual Rate (Item_rate + Item_cost)
        const Actual_Rate =
          (parseFloat(indent.Item_rate) || 0) + (parseFloat(Item_cost) || 0);


        return {
          Sl_no: indent.Sl_no,
          itemCd: indent.itemCd,
          itemDesc: indent.itemDesc,
          UOM: indent.UOM,
          Hsn_code: indent.Hsn_code,
          GST_per: indent.GST_per,
          Indent_loc: indent.Indent_loc,
          Indent_no: indent.Indent_no,
          qty: indent.qty,
          PO_qty: indent.PO_qty,
          Item_rate: indent.Item_rate,
          Gross_amt: indent.Gross_amt,
          Disc_per: indent.Disc_per,
          Disc_amt: indent.Disc_amt,
          Taxable_amt: indent.Taxable_amt,
          Sgst_per: indent.Sgst_per,
          Sgst_amt: (indent.Sgst_per * indent.Taxable_amt) / 100,
          Cgst_per: indent.Cgst_per,
          Cgst_amt: (indent.Cgst_per * indent.Taxable_amt) / 100,
          Igst_per: indent.Igst_per,
          Igst_amt: (indent.Igst_per * indent.Taxable_amt) / 100,
          Ugst_per: 0,
          Ugst_amt: 0,
          Net_amt: indent.Net_amt,
          //  Item_cost: Item_cost,
          Item_cost: Item_cost.toFixed(2),
          Actual_Rate: Actual_Rate.toFixed(2),
        };
      });



    // const totalNetAmt = poDtlData1.reduce(
    //   (sum, item) => sum + parseFloat(item.Net_amt),
    //   0
    // );
    //console.log('this is totalNetAmt',totalNetAmt)
    // const totalAmt =
    //   totalNetAmt +
    //   poHeaderData.Freight_amt +
    //   poHeaderData.Insurance_amt +
    //   poHeaderData.Oth_amt+
    //   poHeaderData.round_amt;

    // poHeaderData1.Net_amt = totalNetAmt.toFixed(2);
    // poHeaderData1.Total_amt = totalAmt.toFixed(2);

    //     const formattedTotalAmt = isNaN(totalAmt) ? 0 : totalAmt;

    // const requestData1 = {
    //   PO_HDR: poHeaderData1,
    //   PO_DTL: poDtlData1,
    //   // Total_amt: formattedTotalAmt.toFixed(2),
    //   Total_amt: poHeaderData1.Total_amt,
    // };


    // ✅ Calculate total additional charges safely
    const totalAdditionalCharges1 =
      Number(poHeaderData1.Freight_amt || 0) +
      Number(poHeaderData1.Insurance_amt || 0) +
      Number(poHeaderData1.Oth_amt || 0) +
      Number(poHeaderData1.round_amt || 0);

    // ✅ Calculate Net total from DTL
    const totalNetAmt = poDtlData1.reduce(
      (sum, item) => sum + Number(item.Net_amt || 0),
      0
    );
    console.log("✅ totalNetAmt:", totalNetAmt);

    // ✅ Compute Total Amount safely
    const totalAmt = totalNetAmt + totalAdditionalCharges1;

    // ✅ Assign properly to PO Header
    poHeaderData1.Net_amt = totalNetAmt.toFixed(2);
    poHeaderData1.Total_amt = isNaN(totalAmt)
      ? "0.00"
      : totalAmt.toFixed(2);

    // ✅ Final request data
    const requestData1 = {
      PO_HDR: poHeaderData1,
      PO_DTL: poDtlData1,
      Total_amt: poHeaderData1.Total_amt,
    };

    // console.log("✅ Final Request Data:", requestData1);


    console.log("PO_no:", PO_no);
    console.log("Request Data:", requestData1);

    if (showApproveForm) {
      try {
        console.log("buttonClick");
        await axios.put(
          `https://erpapi.emedha.in/pages/api/approve/PURCHASE_ORDER/${PO_no}`,
          requestData1
        );
        alert("Purchase Order Approved successfully!");
        window.location.reload();
        fetchPOData();
      } catch (error) {
        alert("Failed to update purchase order. Please try again.");
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
    setPO_no(searchTerm);
    setPoData(null);
    setIsEditing(false);
    if (searchTerm) {
      fetchPOData(searchTerm);
    }
  };
  const [SelectedIndentsss, setSelectedIndentsss] = useState();

  console.log(selectedIndentss);

  const fetchPOData = async () => {
    if (!PO_no) return;

    try {
      const response = await axios.get(
        `https://erpapi.emedha.in/pages/api/PURCHASE_ORDER/${PO_no}`
      );
      const fetchedData = response.data;
      setPoData(fetchedData);
      setPoType(fetchedData.PO_HDR.Po_Type);
      setItemType(fetchedData.PO_HDR.Item_type);
      setDeliTerms(fetchedData.PO_HDR.Deli_terms);
      setPayTerms(fetchedData.PO_HDR.Pay_terms);
      setCreditDays(fetchedData.PO_HDR.Credit_days);
      setDesGst(fetchedData.PO_HDR.Des_gst);
      setDesState(fetchedData.PO_HDR.Des_state_cd);
      setFreightAmt(fetchedData.PO_HDR.Freight_amt);
      setInsuranceAmt(fetchedData.PO_HDR.Insurance_amt);
      setOthAmt(fetchedData.PO_HDR.Oth_amt);
      setRoundAmt(fetchedData.PO_HDR.round_amt);
      setGross_amt(fetchedData.PO_HDR.Gross_amt);
      setDisc_amt(fetchedData.PO_HDR.Disc_amt);
      setTaxable_amt(fetchedData.PO_HDR.Taxable_amt);

      setNet_amt(fetchedData.PO_HDR.Net_amt);
      setTotal_Amt(fetchedData.PO_HDR.Total_amt);
      setCurrency(fetchedData.PO_HDR.currency);
      setExchangeRate(fetchedData.PO_HDR.exchange_rate)

      const supplier = suppliers.find(
        (s) => s.Supp_cd === fetchedData.PO_HDR.Supp_id
      );
      // const suppStateCd = supplier?.Gst_No ? supplier.Gst_No.substring(0, 2) : "N/A";
      const suppStateCd = supplier?.Gst_No
        ? parseInt(supplier.Gst_No.substring(0, 2), 10)
        : null;

      if (supplier) {
        setSelectedSupplier(supplier.Supp_cd);
      }
      console.log(fetchedData.PO_DTL);

      const setSelectedIndentget = fetchedData.PO_DTL.map(
        (detail, index) => `${detail.Indent_no}-${index}-${detail.itemCd}`
      );
      console.log(setSelectedIndentsss);

      setSelectedIndentsss(setSelectedIndentget);

      const selectedIndentss = fetchedData.PO_DTL.map((detail, index) => ({
        Sl_no: detail.Sl_no,
        itemCd: detail.itemCd,
        itemDesc: detail.itemDesc,
        Location_Desc: detail.Location_Desc,
        UOM: detail.UOM,
        Hsn_code: detail.Hsn_code,
        GST_per: detail.GST_per,
        Indent_loc: detail.Indent_loc,
        Indent_no: detail.Indent_no,
        qty: detail.qty,
        PO_qty: detail.PO_qty,
        Item_rate: detail.Item_rate,
        Gross_amt: detail.Gross_amt,
        Disc_per: detail.Disc_per,
        Disc_amt: detail.Disc_amt,
        Taxable_amt: detail.Taxable_amt,
        grpss_amt_fce: detail.grpss_amt_fce,
        Sgst_per: detail.Sgst_per,
        Sgst_amt: detail.Sgst_amt,
        Cgst_per: detail.Cgst_per,
        Cgst_amt: detail.Cgst_amt,
        Igst_per: detail.Igst_per,
        Igst_amt: detail.Igst_amt,
        Ugst_per: detail.Ugst_per,
        Ugst_amt: detail.Ugst_amt,
        Net_amt: detail.Net_amt,
        itemCost: detail.Item_cost,
        Actual_Rate: detail.Actual_Rate,
        Supp_state_cd: suppStateCd,
        Des_state_cd: fetchedData.PO_HDR.Des_state_cd, // Attach Destination State
      }));
      setSelectedIndentss(selectedIndentss);
      console.log(selectedIndentss);
      setIsEditing(true);
    } catch (err) {
      console.error("Error fetching PO data", err);
    }
  };

  useEffect(() => {
    if (PO_no) {
      fetchPOData();
    }
  }, [PO_no]);

  const [visibleRows, setVisibleRows] = useState();
  console.log(visibleRows);

  useEffect(() => {
    const totalRows = selectedIndentss.length;
    const emptyRowsNeeded = totalRows < 10 ? 10 - totalRows : 0;
    setVisibleRows([...selectedIndentss, ...Array(emptyRowsNeeded).fill({})]);
  }, [selectedIndentss]);

  const handleEditInputChange = (e, indent_no, field, index) => {
    console.log("buttonClick");
    const value = e.target.value;
    console.log(value);
    console.log(`Updating ${field} for indent ${indent_no}: ${value}`);

    setVisibleRows((prevIndents) => {
      return prevIndents.map((indent, i) => {
        if (indent.Indent_no === indent_no && i === index) {
          const updatedIndent = { ...indent, [field]: value };

          // Log the updatedIndent object to see the data structure
          console.log("Updated Indent Object:", updatedIndent);

          // Recalculate gross amount, discount amount, and taxable amount
          const grossAmt = calculateGrossAmt(
            updatedIndent.PO_qty,
            updatedIndent.Item_rate
          );
          const discAmt = calculateDiscAmt(grossAmt, updatedIndent.Disc_per);
          const taxableAmt = calculateTaxableAmt(grossAmt, discAmt);
          console.log(discAmt);

          // Default values for taxes
          let sgstPer = 0;
          let cgstPer = 0;
          let igstPer = 0;
          let sgstAmt = 0;
          let cgstAmt = 0;
          let igstAmt = 0;

          // Ensure updatedIndent has the correct state values
          const supplierState = updatedIndent.Supp_state_cd; // Make sure Supp_state_cd exists
          const destinationState = updatedIndent.Des_state_cd; // Make sure Des_state_cd exists

          console.log("Supplier State:", supplierState); // Log the supplier state
          console.log("Destination State:", destinationState); // Log the destination state

          // Check if the Supplier and Destination states are the same
          if (supplierState && destinationState) {
            if (supplierState === destinationState) {
              // **Both states are the same**: SGST and CGST are calculated
              sgstPer = cgstPer = updatedIndent.GST_per / 2; // Divide GST per by 2 for SGST and CGST
              sgstAmt = (sgstPer * taxableAmt) / 100;
              cgstAmt = (cgstPer * taxableAmt) / 100;
              igstAmt = 0; // No IGST when states match
            } else {
              // **States are different**: IGST is calculated
              igstPer = updatedIndent.GST_per;
              igstAmt = (igstPer * taxableAmt) / 100;
              sgstAmt = 0; // No SGST
              cgstAmt = 0; // No CGST
            }
          } else {
            // If states are undefined, log it out for debugging purposes
            console.log(
              "Error: Either Supplier or Destination state is undefined"
            );
          }

          // Update the indent with recalculated values
          updatedIndent.Gross_amt = grossAmt;
          updatedIndent.Disc_amt = discAmt;
          updatedIndent.Taxable_amt = taxableAmt;
          updatedIndent.Sgst_amt = sgstAmt;
          updatedIndent.Cgst_amt = cgstAmt;
          updatedIndent.Igst_amt = igstAmt;
          updatedIndent.Net_amt = taxableAmt + sgstAmt + cgstAmt + igstAmt;

          return updatedIndent;
        }
        return indent;
      });
    });

    updatePOHeader();
  };

  const updatePOHeader = () => {
    const grossAmt = visibleRows.reduce(
      (sum, indent) => sum + (indent.Gross_amt || 0),
      0
    );
    const discAmt = visibleRows.reduce(
      (sum, indent) => sum + (indent.Disc_amt || 0),
      0
    );
    const taxableAmt = visibleRows.reduce(
      (sum, indent) => sum + (indent.Taxable_amt || 0),
      0
    );
    const netAmt = visibleRows.reduce(
      (sum, indent) => sum + (indent.Net_amt || 0),
      0
    );
    console.log("Updated PO Header:", {
      grossAmt,
      discAmt,
      taxableAmt,
      netAmt,
      Total_amt,
    });

    // Calculate Total Amount including Freight, Insurance, Other Charges
    const totalAmt =
      netAmt +
      parseFloat(Freight_amt || 0) +
      parseFloat(Insurance_amt || 0) +
      parseFloat(Oth_amt || 0) +
      parseFloat(round_amt || 0);

    // Update state values for the PO Header
    setGross_amt(grossAmt);
    setDisc_amt(discAmt);
    setTaxable_amt(taxableAmt);
    setNet_amt(netAmt);
    setTotal_Amt(totalAmt);
  };

  const handleRefresh = () => {
    setPO_no("");
    setPoType("CAPX");
    setDeliTerms("");
    setDeliveryDate("");
    setDesGst("");
    setDesState("");
    setPayTerms("");
    setItemType("Import");
    setCreditDays("");
    setSelectedSupplier("");
    setFreightAmt("");
    setInsuranceAmt("");
    setOthAmt("");
    setRoundAmt("");
    setTotal_Amt("");
    setItems([]);
    setIndents([]);
    setSelectedIndents([]);
  };

  // const handleApprove = (id) => {
  //   console.log('Data after approval:');
  // };

  const handlePrint = () => { };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const [formMode, setFormMode] = useState("");
  // const userPermissions = user ? {
  //   add: user.add_permission,
  //   edit: user.edit_permission,
  //   view: user.view_permission,
  //   save: user.save_permission,
  //   approve: user.approve_permission,
  //   print: user.print_permission,
  //   close: user.close_permission,
  //   clear: user.clear_screen_permission
  // } : {};
  const userPermissions =
    user && user.permissions && user.permissions[1000]
      ? {
        add:
          user.permissions[2000].sub_ids[2002]?.permissions.add_permission ||
          0,
        edit:
          user.permissions[2000].sub_ids[2002]?.permissions.edit_permission ||
          0,
        view:
          user.permissions[2000].sub_ids[2002]?.permissions.view_permission ||
          0,
        save:
          user.permissions[2000].sub_ids[2002]?.permissions.save_permission ||
          0,
        approve:
          user.permissions[2000].sub_ids[2002]?.permissions
            .approve_permission || 0,
        print:
          user.permissions[2000].sub_ids[2002]?.permissions
            .print_permission || 0,
        close:
          user.permissions[2000].sub_ids[2002]?.permissions.exit_permission ||
          0,
        clear:
          user.permissions[2000].sub_ids[2002]?.permissions
            .refresh_permission || 0,
      }
      : {};

  const getButtonState = (permissionType) => {
    switch (formMode) {
      case "create":
        return (
          permissionType === "create" ||
          permissionType === "clear" ||
          permissionType === "save" ||
          permissionType === "close"
        );
      case "edit":
        return (
          permissionType === "edit" ||
          permissionType === "clear" ||
          permissionType === "save" ||
          permissionType === "close"
        );
      case "view":
        return (
          permissionType === "view" ||
          permissionType === "clear" ||
          permissionType === "close"
        );
      case "approve":
        return (
          permissionType === "clear" ||
          permissionType === "approve" ||
          permissionType === "print" ||
          permissionType === "close"
        );
      default:
        return false;
    }
  };

  //get Indent_loc from Location Desc
  const [locationDescMapping, setLocationDescMapping] = useState({});

  const fetchLocationDescriptions = async () => {
    try {
      const response = await axios.get(
        "https://erpapi.emedha.in/pages/api/location-description/"
      ); // Assuming this is the API endpoint for fetching the location descriptions
      const locations = response.data; // Example: [{ "1": "HO" }, { "2": "NY" }]
      const mapping = {};

      // Create a mapping from Indent_loc to Location_Desc
      locations.forEach((location) => {
        const indent_loc = Object.keys(location)[0]; // Extract the key (Indent_loc)
        mapping[indent_loc] = location[indent_loc]; // Extract the value (Location_Desc)
      });

      setLocationDescMapping(mapping); // Set the mapping to state
    } catch (error) {
      console.error("Error fetching location descriptions:", error);
    }
  };

  useEffect(() => {
    fetchLocationDescriptions();
  }, []);

  // this is item cost useEffects code 

  useEffect(() => {
    if (!combinedData || combinedData.length === 0) return;

    const freight = parseFloat(Freight_amt) || 0;
    const insurance = parseFloat(Insurance_amt) || 0;
    const other = parseFloat(Oth_amt) || 0;
    const totalExtras = freight + insurance + other;

    // Calculate totalNetAmt (same as footer)
    const totalNetAmt =
      Item_type === "Local"
        ? combinedData
          .filter((indent, i) =>
            selectedIndents.includes(`${indent.indent_no}-${i}-${indent.itemCd}`)
          )
          .reduce((total, indent) => {
            const taxableAmt = calculateTaxableAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              calculateDiscAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                indent.Disc_per
              )
            );
            return (
              total +
              taxableAmt +
              (indent.sgstAmt || 0) +
              (indent.cgstAmt || 0) +
              (indent.igstAmt || 0)
            );
          }, 0)
        : Item_type === "Import"
          ? combinedData
            .filter((indent, i) =>
              selectedIndents.includes(`${indent.indent_no}-${i}-${indent.itemCd}`)
            )
            .reduce((total, indent) => {
              const taxableAmt = calculateTaxableAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                calculateDiscAmt(
                  calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                  indent.Disc_per
                )
              );
              return total + taxableAmt * exchange_rate;
            }, 0)
          : 0;

    // Calculate each item’s cost proportionally
    const updatedCosts = combinedData.map((indent, i) => {
      const rowNetAmount =
        Item_type === "Local"
          ? (
            calculateTaxableAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              calculateDiscAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                indent.Disc_per
              )
            ) +
            (indent.sgstAmt || 0) +
            (indent.cgstAmt || 0) +
            (indent.igstAmt || 0)
          )
          : Item_type === "Import"
            ? (
              calculateTaxableAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                calculateDiscAmt(
                  calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                  indent.Disc_per
                )
              ) * exchange_rate
            )
            : 0;

      const proportionalValue =
        totalNetAmt > 0 ? (totalExtras * rowNetAmount) / totalNetAmt : 0;

      return {
        indent_no: indent.indent_no,
        itemCd: indent.itemCd,
        itemCost: parseFloat(proportionalValue.toFixed(2)),
      };
    });

    setItemCosts(updatedCosts);
  }, [
    Freight_amt,
    Insurance_amt,
    Oth_amt,
    combinedData,
    selectedIndents,
    Item_type,
    exchange_rate,
  ]);

  const totalNetAmtt = visibleRows?.reduce((sum, item) => {
    const isImport = item?.Item_type?.toLowerCase() === "import";
    const net = parseFloat(isImport ? item?.grpss_amt_fce : item?.Net_amt) || 0;
    return sum + net;
  }, 0);


  // css 

  const iconBox = (enabled) => ({
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
    boxShadow: enabled ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
    cursor: enabled ? "pointer" : "not-allowed",
    opacity: enabled ? 1 : 0.5,
    transition: "all 0.3s ease",
  });

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  };

  const titleStyle = {
    color: "#1e3a8a",
    fontSize: "2rem",
    fontWeight: "700",
    letterSpacing: "1px",
  };

  const iconContainer = {
    display: "flex",
    gap: "14px",
    alignItems: "center",
  };


  return (
    <>
      <div
        style={{
          margin: "0 auto",
          backgroundColor: "#ffffff",
          padding: "1rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          border: "1px solid black",
          borderRadius: "10px",
        }}
      >
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src={A1} alt="item" style={{ width: "20%" }} />
          <h1
            style={{
              color: "darkblue",
              fontSize: "1.95rem",
              fontWeight: "1000",
              marginBottom: "1rem",
            }}
          >
            PURCHASE ORDER
          </h1>
          <div style={{ display: "flex", gap: "1rem", cursor: "pointer" }}>
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.add && userPermissions.add !== 0
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.add &&
                    userPermissions.add !== 0 &&
                    getButtonState("create")
                    ? 1
                    : 0.5,
              }}
            >
              <FaPlus
                size={30}
                onClick={() => {
                  if (userPermissions.add && userPermissions.add !== 0) {
                    toggleModal();
                    setShowEditFormm(false);
                    setShowCreateForm(true);
                    setShowApproveForm(false);
                    setFormMode("create");
                  }
                }}
              />
            </div>
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.edit && userPermissions.edit !== 0
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.edit &&
                    userPermissions.edit !== 0 &&
                    getButtonState("edit")
                    ? 1
                    : 0.5,
              }}
            >
              <MdEdit
                size={30}
                onClick={() => {
                  if (userPermissions.edit && userPermissions.edit !== 0) {
                    setShowEditFormm(true);
                    setShowCreateForm(false);
                    setShowApproveForm(false);
                    setFormMode("edit");
                    setIsEditing(true);
                  } else {
                    alert("You do not have permission to edit.");
                  }
                }}
              />
            </div>
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.view && userPermissions.view !== 0
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.view &&
                    userPermissions.view !== 0 &&
                    getButtonState("view")
                    ? 1
                    : 0.5,
              }}
            >
              <LuView
                size={30}
                onClick={() => {
                  if (userPermissions.view && userPermissions.view !== 0) {
                    setShowEditFormm(true);
                    setShowCreateForm(false);
                    setShowApproveForm(false);
                    setFormMode("view");
                  } else {
                    alert("You do not have permission to view.");
                  }
                }}
              />
            </div>
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.clear &&
                    userPermissions.clear !== 0 &&
                    getButtonState("clear")
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.clear &&
                    userPermissions.clear !== 0 &&
                    getButtonState("clear")
                    ? 1
                    : 0.5,
              }}
            >
              <HiOutlineRefresh
                size={30}
                onClick={
                  userPermissions.clear && userPermissions.clear !== 0
                    ? handleRefresh
                    : null
                }
              />
            </div>

            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.save &&
                    userPermissions.save !== 0 &&
                    getButtonState("save")
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.save &&
                    userPermissions.save !== 0 &&
                    getButtonState("save")
                    ? 1
                    : 0.5,
              }}
            >
              <FaSave
                size={30}
                onClick={() => {
                  if (userPermissions.save && userPermissions.save !== 0) {
                    if (formMode === "approve") {
                      handleApprove(); // If formMode is approve, use handleApprove
                    } else if (formMode === "create" || formMode === "edit") {
                      handleSave(); // If formMode is create or edit, use handleSave
                    }
                  } else {
                    alert("You do not have permission to save.");
                  }
                }}
              />
            </div>

            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.approve &&
                    userPermissions.approve !== 0 &&
                    getButtonState("approve")
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.approve &&
                    userPermissions.approve !== 0 &&
                    getButtonState("approve")
                    ? 1
                    : 0.5,
              }}
            >
              <FaCheck
                size={30}
                onClick={() => {
                  if (
                    userPermissions.approve &&
                    userPermissions.approve !== 0
                  ) {
                    setShowEditFormm(false);
                    setShowCreateForm(false);
                    setShowApproveForm(true);

                    setFormMode("approve");
                  } else {
                    alert("You do not have permission to view.");
                  }
                }}
              />
            </div>

            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.print &&
                    userPermissions.print !== 0 &&
                    getButtonState("print")
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.print &&
                    userPermissions.print !== 0 &&
                    getButtonState("print")
                    ? 1
                    : 0.5,
              }}
              title="Print"
            >
              <IoPrint
                size={30}
                onClick={
                  userPermissions.print && userPermissions.print !== 0
                    ? handlePrint
                    : null
                }
              />
            </div>
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor:
                  userPermissions.close &&
                    userPermissions.close !== 0 &&
                    getButtonState("close")
                    ? "pointer"
                    : "not-allowed",
                opacity:
                  userPermissions.close &&
                    userPermissions.close !== 0 &&
                    getButtonState("close")
                    ? 1
                    : 0.5,
              }}
              title="Exit"
            >
              <RiCloseLargeFill
                size={30}
                onClick={
                  userPermissions.close && userPermissions.close !== 0
                    ? handleBack
                    : null
                }
              />
            </div>
          </div>
        </div> */}

        <div style={headerStyle}>

          {/* Logo */}
          <img src={A1} alt="purchase-order" style={{ width: "270px", borderRadius: "10px" }} />

          {/* Title */}
          <h1 style={titleStyle}>PURCHASE ORDER</h1>

          {/* Actions */}
          <div style={iconContainer}>

            {/* Add */}
            <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState("create"))}>
              <FaPlus size={20} color="#2563eb"
                onClick={() => {
                  if (userPermissions.add && userPermissions.add !== 0) {
                    toggleModal();
                    setShowEditFormm(false);
                    setShowCreateForm(true);
                    setShowApproveForm(false);
                    setFormMode("create");
                  }
                }}
              />
            </div>

            {/* Edit */}
            <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState("edit"))}>
              <MdEdit size={20} color="#f59e0b"
                onClick={() => {
                  if (userPermissions.edit && userPermissions.edit !== 0) {
                    setShowEditFormm(true);
                    setShowCreateForm(false);
                    setShowApproveForm(false);
                    setFormMode("edit");
                    setIsEditing(true);
                  } else {
                    alert("You do not have permission to edit.");
                  }
                }}
              />
            </div>

            {/* View */}
            <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState("view"))}>
              <LuView size={20} color="#10b981"
                onClick={() => {
                  if (userPermissions.view && userPermissions.view !== 0) {
                    setShowEditFormm(true);
                    setShowCreateForm(false);
                    setShowApproveForm(false);
                    setFormMode("view");
                  } else {
                    alert("You do not have permission to view.");
                  }
                }}
              />
            </div>

            {/* Refresh */}
            <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState("clear"))}>
              <HiOutlineRefresh size={20} color="#6366f1"
                onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
              />
            </div>

            {/* Save */}
            <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState("save"))}>
              <FaSave size={20} color="#22c55e"
                onClick={() => {
                  if (userPermissions.save && userPermissions.save !== 0) {
                    if (formMode === "approve") {
                      handleApprove();
                    } else if (formMode === "create" || formMode === "edit") {
                      handleSave();
                    }
                  } else {
                    alert("You do not have permission to save.");
                  }
                }}
              />
            </div>

            {/* Approve */}
            <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState("approve"))}>
              <FaCheck size={20} color="#16a34a"
                onClick={() => {
                  if (userPermissions.approve && userPermissions.approve !== 0) {
                    setShowEditFormm(false);
                    setShowCreateForm(false);
                    setShowApproveForm(true);
                    setFormMode("approve");
                  } else {
                    alert("You do not have permission to view.");
                  }
                }}
              />
            </div>

            {/* Print */}
            <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState("print"))} title="Print">
              <IoPrint size={20} color="#0ea5e9"
                onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
              />
            </div>

            {/* Close */}
            <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState("close"))} title="Exit">
              <RiCloseLargeFill size={20} color="#ef4444"
                onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
              />
            </div>

          </div>
        </div>


        <hr />

                        {!showCreateForm && !showEditformm && !showApproveForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}

        {showCreateForm && (
          <>
            {isModalOpen && (
              <div
                style={{
                  position: "fixed",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#dbc4a9",
                    padding: "16px",
                    borderRadius: "8px",
                    width: "80%",
                  }}
                >
                  <h4 className="text-center">PENDING INDENT</h4>
                  <div style={{ overflowY: "auto", maxHeight: "200px" }}>
                    <table
                      style={{
                        minWidth: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid black",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Location
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Indent No
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Indent Dt
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Item
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Item desc
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            QTY
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            UOM
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Approved Qty
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Supplier
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Remarks
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              textAlign: "center",
                              color: "darkblue",
                            }}
                          >
                            Selections
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {combinedData.map((indent, index) => {
                          console.log('Thisis CombainData INdent ', indent, 'this is index', index)
                          const key = `${indent.indent_no}-${index}-${indent.itemCd}`;
                          return (
                            // <tr key={index}>
                            <tr key={`${indent.indent_no}-${index}-${indent.itemCd}`}>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.Location_Desc}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.indent_no}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {new Date(
                                  indent.Indent_dt
                                ).toLocaleDateString()}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.itemCd}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.itemDesc}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.qty}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.itemUOM}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.Approved_qty}
                                {/* {indent.pending_qty */}

                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.Supp_Nm}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                {indent.all_remarks}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "8px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedIndents.includes(
                                    `${indent.indent_no}-${index}-${indent.itemCd}`
                                  )}
                                  onChange={() =>
                                    handleIndentSelection(
                                      indent.indent_no,
                                      index,
                                      indent.itemCd
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ marginTop: "16px" }}>
                    <button
                      style={{
                        backgroundColor: "blue",
                        color: "white",
                        padding: "2px 20px",
                        borderRadius: "4px",
                        marginRight: "10px",
                        cursor: "pointer",
                      }}
                      onClick={handleIndentAdd}
                    >
                      Add
                    </button>
                    <button
                      style={{
                        backgroundColor: "blue",
                        color: "white",
                        padding: "2px 20px",
                        borderRadius: "4px",
                        marginRight: "10px",
                        cursor: "pointer",
                      }}
                      onClick={toggleModal}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isDataVisible && selectedIndents.length > 0 && (
              <div style={{ marginTop: "32px" }}>
                <div
                  className="p-1"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "16px",
                  }}
                >
                  <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "10px", color: "darkblue" }}>
                        Purchase Order No:
                      </label>
                      <input
                        type="number"
                        name="PO_no"
                        readOnly
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "86px", color: "darkblue" }}>
                        PO Type:
                      </label>
                      <select
                        name="Po_Type"
                        value={Po_Type}
                        onChange={(e) => setPoType(e.target.value)}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <option value="CAPX">CAPX</option>
                        <option value="OPEX">OPEX</option>
                      </select>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "42px", color: "darkblue" }}>
                        Delivery Terms:
                      </label>
                      <input
                        type="text"
                        name="Deli_terms"
                        value={Deli_terms}
                        onChange={(e) => setDeliTerms(e.target.value)}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength="20"
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "67px", color: "darkblue" }}>
                        Delivery Dt:
                      </label>
                      <input
                        type="date"
                        name="Deli_dt"
                        value={deliveryDate}
                        onChange={(e) => setDeliveryDate(e.target.value)}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "32px", color: "darkblue" }}>
                        Destination GST:
                      </label>
                      <input
                        readOnly
                        name="Des_gst"
                        value={Des_gst}
                        onChange={handleDesGstChange}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength="12"
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "24px", color: "darkblue" }}>
                        Destination State:
                      </label>
                      <input
                        readOnly
                        name="Des_state_cd"
                        value={Des_state_cd}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "65px", color: "darkblue" }}>
                        P O Dt:
                      </label>
                      <input
                        type="date"
                        name="PO_Dt"
                        value={PO_Dt}
                        onChange={(e) => setPoDate(e.target.value)}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "42px", color: "darkblue" }}>
                        Item Type:
                      </label>
                      <select
                        name="Item_type"
                        value={Item_type}
                        // onChange={(e) => setItemType(e.target.value)}
                        onChange={handleItemTypeChange}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <option value="Import">Import</option>
                        <option value="Local">Local</option>
                      </select>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "4px", color: "darkblue" }}>
                        Payment Terms:
                      </label>
                      <input
                        type="text"
                        name="Pay_terms"
                        value={Pay_terms}
                        onChange={(e) => setPayTerms(e.target.value)}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength="20"
                      />
                    </div>
                    {/* <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '53px', color: 'darkblue' }}>Curency:</label>
                      <select name="Item_type" value={currency} onChange={(e) => setCurrency(e.target.value)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }}>
                        <option value="INR">INR</option>
                        <option value="USD">USD</option>
                        <option value="UERO">UERO</option>
                      </select>
                    </div> */}
                    {/* <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '7px', color: 'darkblue' }}>Exchange Rate:</label>
                      <input type="text" name="Pay_terms" value={exchange_rate} onChange={(e) => setExchangeRate(e.target.value)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} maxLength="20" />
                    </div> */}

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "47px", color: "darkblue" }}>
                        Currency:
                      </label>
                      <select
                        name="currency"
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        disabled={Item_type === "Local"} // Disable if Local is selected
                      >
                        {Item_type === "Import" ? (
                          <>
                            <option value="USD">USD</option>
                            <option value="EURO">EURO</option>
                          </>
                        ) : (
                          <option value="INR">INR</option>
                        )}
                      </select>
                    </div>
                    {Item_type === "Import" && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          style={{ marginRight: "7px", color: "darkblue" }}
                        >
                          Exchange Rate:
                        </label>
                        <input
                          type="text"
                          name="exchange_rate"
                          value={exchange_rate}
                          onChange={(e) => setExchangeRate(e.target.value)}
                          style={{
                            border: "none",
                            borderLeft: "2px solid #D1D5DB",
                            padding: "2px",
                            width: "50%",
                            outline: "none",
                            backgroundColor: "transparent",
                          }}
                          maxLength="20"
                        />
                      </div>
                    )}

                    {/* {Item_type === 'Import' ? (
                      <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <label style={{ marginRight: '47px', color: 'darkblue' }}>Currency:</label>
                          <select
                            name="currency"
                            value={currency}
                            onChange={(e) => setCurrency(e.target.value)}
                            style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }}
                          >
                            <option value="USD">USD</option>
                            <option value="EURO">EURO</option>
                          </select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <label style={{ marginRight: '7px', color: 'darkblue' }}>Exchange Rate:</label>
                          <input
                            type="text"
                           name="exchange_rate"
                            value={exchange_rate}
                            onChange={(e) => setExchangeRate(e.target.value)}
                            style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }}
                            maxLength="20"
                          />
                        </div>
                      </>
                    ) : (
                      // When "Local" is selected
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginRight: '47px', color: 'darkblue' }}>Currency:</label>
                        <select
                          name="currency"
                          value="INR"
                          onChange={(e) => setCurrency('INR')}
                          style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }}
                          disabled
                        >
                          <option value="INR">INR</option>
                        </select>
                      </div>
                    )} */}
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "44px", color: "darkblue" }}>
                        Supplier:
                      </label>
                      {/* <select onChange={handleSupplierChange} value={Supp_id} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} >
                        <option value="">Select</option>
                        {suppliers.map((supplier) => (<option key={supplier.Supp_cd} value={supplier.Supp_cd}>{supplier.Supp_Nm}</option>))}
                      </select> */}
                      <Select
                        options={suppliers.map((supplier) => ({
                          value: supplier.Supp_cd,
                          label: `${supplier.Supp_Nm}-${supplier.Supp_cd}`,
                        }))}
                        onChange={handleSupplierChange1}
                        value={
                          Supp_id
                            ? {
                              value: Supp_id,
                              label:
                                suppliers.find(
                                  (supplier) => supplier.Supp_cd === Supp_id
                                )?.Supp_Nm || "",
                            }
                            : null
                        }
                        isDisabled={formMode === "approve"}
                        placeholder="Select Supplier"
                        // isClearable={true}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "90%",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menu: (provided) => ({
                            ...provided,
                            width: "100%",

                            overflowY: "auto",
                          }),
                          control: (provided) => ({
                            ...provided,
                            backgroundColor: "transparent",

                            padding: "4px",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: "black",
                          }),
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "22px", color: "darkblue" }}>
                        Credit Days:
                      </label>
                      <input
                        type="number"
                        name="Credit_days"
                        value={Credit_days}
                        onChange={handleCreditDaysChange}
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "13px", color: "darkblue" }}>
                        Supplier GST:
                      </label>
                      <input
                        type="text"
                        name="Supp_gst"
                        value={supplier ? supplier.Gst_No : ""}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ marginRight: "6px", color: "darkblue" }}>
                        Supplier State:
                      </label>
                      <input
                        type="text"
                        name="Supp_state_cd"
                        value={
                          supplier ? extractStateFromGST(supplier.Gst_No) : ""
                        }
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          padding: "2px",
                          width: "50%",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="table-responsive"
                  style={{ overflowY: "auto", maxHeight: "235px" }}
                >
                  <div>
                    <table
                      className="table  "
                      style={{
                        minWidth: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid black",
                      }}
                    >
                      <thead style={{ fontSize: '13px' }}>
                        <tr>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",

                            }}
                          >
                            Sl
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Item Code
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Item Description
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            UOM
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            HSN CODE
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            GST %
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Indent Location
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Indent No
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Indent Qty
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Approved Qty
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            PO Qty
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Item Rate
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Gross Amt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Disc %
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Disc Amtt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Taxable amt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Gross Amt(FC)
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            SGST %
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            SGST AMT
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            CGST %
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            CGST Amt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            IGST %
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            IGST Amt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            UGST %
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            UGST Amt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Net Amt
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Item Costs
                          </th>
                          <th
                            className="text-center "
                            style={{
                              border: "1px solid black",
                              backgroundColor: "#DCC4AA",
                            }}
                          >
                            Actually Rate
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        {combinedData
                          .filter((indent, index) => selectedIndents.includes(`${indent.indent_no}-${index}-${indent.itemCd}`
                          )).map((indent, index) => {
                            const key = `${indent.indent_no}-${index}-${indent.itemCd}`;
                            console.log('this is indent 5432', indent)
                            return (
                              <tr key={key}>
                                <td style={{ border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"                                >                                  {index + 1}                                </td>
                                <td style={{ minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center "                                >                                  {indent.itemCd}                                </td>
                                <td style={{
                                  minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"                                >                                  {indent.itemDesc}                                </td>
                                <td style={{
                                  minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"                                >                                  {indent.itemUOM}                                </td>
                                <td style={{ minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"                                >                                  {indent.hsnCode}                                </td>
                                <td style={{
                                  minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"                                >                                  {indent.taxRate}                                </td>
                                <td style={{ minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"                               >                                  {indent.Location_Desc}                                </td>
                                <td style={{
                                  minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"                                >                                  {indent.indent_no}                                </td>
                                <td style={{
                                  minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"                                >                                  {indent.qty}                                </td>
                                <td style={{ minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"                                >                                  {indent.Approved_qty}                                </td>

                                <td style={{ minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"                                >                                  <input type="text" name="PO_qty" value={indent.PO_qty}
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      console.log('this is inputValue 5581', inputValue)
                                      // Check if the input value is greater than indent.qty
                                      if (
                                        parseInt(inputValue) >
                                        indent.Approved_qty
                                      ) {
                                        alert(
                                          `You cannot enter more than ${indent.Approved_qty}.Please enter a value less than or equal to ${indent.Approved_qty}.`
                                        );
                                        e.target.value = ""; // Clear the input value if it exceeds the limit
                                        return;
                                      }

                                      if (inputValue.includes(".")) {
                                        let parts = inputValue.split(".");
                                        if (parts[1] && parts[1].length > 2) {
                                          e.target.value =
                                            parts[0] +
                                            "." +
                                            parts[1].slice(0, 2);
                                        }
                                      }

                                      console.log("Indent No 5604:", indent.indent_no);
                                      console.log("Field Name:", "PO_qty");
                                      console.log("Index:", index);
                                      console.log("Item Code:", indent.itemCd);

                                      handleInputChange(e, indent.indent_no, "PO_qty", index, indent.itemCd);
                                    }}
                                    onClick={() => {
                                      if (!Supp_id) {
                                        alert("Please select a supplier before entering the PO quantity."
                                        );
                                        return;
                                      }
                                    }}
                                    autoComplete="off"

                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck="false"
                                    className="form-control"
                                    style={{ minWidth: "100px", border: "1px solid #DCC4AA", backgroundColor: "#DCC4AA", }}
                                    maxLength={10} />
                                </td>
                                <td style={{ border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"                                >
                                  <input
                                    type="text" name="Item_rate" value={indent.Item_rate} onChange={(e) => {
                                      if (!Supp_id) {
                                        alert(
                                          "Please select a supplier before entering the PO quantity."
                                        );
                                        return;
                                      }

                                      // Get the value from the input
                                      const inputValue = e.target.value;
                                      // Check if a decimal is entered
                                      if (inputValue.includes(".")) {
                                        // If decimal is present, ensure only two digits after the decimal
                                        let parts = inputValue.split(".");
                                        if (parts[1] && parts[1].length > 2) {
                                          // Limit the digits to 2 after the decimal
                                          e.target.value =
                                            parts[0] +
                                            "." +
                                            parts[1].slice(0, 2);
                                        }
                                      }

                                      handleInputChange(e, indent.indent_no, "Item_rate", index, indent.itemCd);
                                    }}
                                    onClick={() => {
                                      if (!Supp_id) {
                                        alert(
                                          "Please select a supplier before entering the PO quantity."
                                        );
                                        return;
                                      }
                                    }}
                                    autoComplete="off"

                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck="false"
                                    className="form-control"
                                    style={{ minWidth: "100px", border: "1px solid #DCC4AA", backgroundColor: "#DCC4AA", }} // Allowing minimum width
                                    maxLength={10}
                                    pattern="[0-9]+(\.[0-9]{1,2})?"
                                  />                                </td>
                                <td style={{
                                  minWidth: "90px", border: "1px solid black",
                                  backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"
                                >
                                  {isNaN(
                                    calculateGrossAmt(
                                      indent.PO_qty,
                                      indent.Item_rate
                                    )
                                  )
                                    ? ""
                                    : calculateGrossAmt(
                                      indent.PO_qty,
                                      indent.Item_rate
                                    ).toFixed(2)}
                                </td>
                                <td style={{
                                  border: "1px solid black", backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"
                                >
                                  <input
                                    type="text"
                                    name="Disc_per"
                                    onChange={(e) => {
                                      if (!Supp_id) {
                                        alert(
                                          "Please select a supplier before entering the PO quantity."
                                        );
                                        return;
                                      }

                                      // Get the value from the input
                                      const inputValue = e.target.value;
                                      // Check if a decimal is entered
                                      if (inputValue.includes(".")) {
                                        // If decimal is present, ensure only two digits after the decimal
                                        let parts = inputValue.split(".");
                                        if (parts[1] && parts[1].length > 2) {
                                          // Limit the digits to 2 after the decimal
                                          e.target.value =
                                            parts[0] +
                                            "." +
                                            parts[1].slice(0, 2);
                                        }
                                      }
                                      handleInputChange(
                                        e,
                                        indent.indent_no,
                                        "Disc_per",
                                        index,
                                        indent.itemCd
                                      );
                                    }}
                                    onClick={() => {
                                      if (!Supp_id) {
                                        alert(
                                          "Please select a supplier before entering the PO quantity."
                                        );
                                        return;
                                      }
                                    }}
                                    value={indent.Disc_per}
                                    autoComplete="off"

                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck="false"
                                    className="form-control"
                                    style={{
                                      minWidth: "100px",
                                      border: "1px solid #DCC4AA",
                                      backgroundColor: "#DCC4AA",
                                    }}
                                    maxLength={10}
                                    pattern="[0-9]+(\.[0-9]{1,2})?"
                                  />
                                </td>
                                <td
                                  style={{ minWidth: "90px", border: "1px solid black", backgroundColor: "#DCC4AA", }}
                                  className="text-center"
                                >
                                  {isNaN(
                                    calculateDiscAmt(
                                      calculateGrossAmt(
                                        indent.PO_qty,
                                        indent.Item_rate
                                      ),
                                      indent.Disc_per
                                    )
                                  )
                                    ? ""
                                    : calculateDiscAmt(
                                      calculateGrossAmt(
                                        indent.PO_qty,
                                        indent.Item_rate
                                      ),
                                      indent.Disc_per
                                    ).toFixed(2)}
                                </td>

                                <td style={{
                                  minWidth: "90px", border: "1px solid black",
                                  backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center"                                >
                                  {isNaN(
                                    calculateTaxableAmt(
                                      calculateGrossAmt(
                                        indent.PO_qty,
                                        indent.Item_rate
                                      ),
                                      calculateDiscAmt(
                                        calculateGrossAmt(
                                          indent.PO_qty,
                                          indent.Item_rate
                                        ),
                                        indent.Disc_per
                                      )
                                    )
                                  )
                                    ? ""
                                    : calculateTaxableAmt(
                                      calculateGrossAmt(
                                        indent.PO_qty,
                                        indent.Item_rate
                                      ),
                                      calculateDiscAmt(
                                        calculateGrossAmt(
                                          indent.PO_qty,
                                          indent.Item_rate
                                        ),
                                        indent.Disc_per
                                      )
                                    ).toFixed(2)}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {
                                    // Check if the result of the calculation is a valid number (not NaN)
                                    isNaN(
                                      calculateTaxableAmt(
                                        calculateGrossAmt(
                                          indent.PO_qty,
                                          indent.Item_rate
                                        ),
                                        calculateDiscAmt(
                                          calculateGrossAmt(
                                            indent.PO_qty,
                                            indent.Item_rate
                                          ),
                                          indent.Disc_per
                                        )
                                      )
                                    )
                                      ? "" // If the result is not a valid number, display an empty string
                                      : (
                                        calculateTaxableAmt(
                                          calculateGrossAmt(
                                            indent.PO_qty,
                                            indent.Item_rate
                                          ),
                                          calculateDiscAmt(
                                            calculateGrossAmt(
                                              indent.PO_qty,
                                              indent.Item_rate
                                            ),
                                            indent.Disc_per
                                          )
                                        ) * exchange_rate
                                      ).toFixed(2) // If it's valid, multiply by 22 and display the result rounded to 2 decimal places
                                  }
                                </td>


                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.sgstPer}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.sgstAmt
                                    ? indent.sgstAmt.toFixed(2)
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.cgstPer
                                    ? indent.cgstPer.toFixed(2)
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.cgstAmt
                                    ? indent.cgstAmt.toFixed(2)
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.igstPer
                                    ? indent.igstPer.toFixed(2)
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.igstAmt
                                    ? indent.igstAmt.toFixed(2)
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.ugstper
                                    ? indent.ugstper.toFixed(2)
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local" && indent.ugstAmt
                                    ? indent.ugstAmt.toFixed(2)
                                    : ""}
                                </td>



                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {Item_type === "Local"
                                    ? // Display calculation for 'Local'
                                    (
                                      calculateTaxableAmt(
                                        calculateGrossAmt(
                                          indent.PO_qty,
                                          indent.Item_rate
                                        ),
                                        calculateDiscAmt(
                                          calculateGrossAmt(
                                            indent.PO_qty,
                                            indent.Item_rate
                                          ),
                                          indent.Disc_per
                                        )
                                      ) +
                                      indent.sgstAmt +
                                      indent.cgstAmt +
                                      indent.igstAmt
                                    ).toFixed(2)
                                    : // Display different calculation for 'Import'
                                    Item_type === "Import" &&
                                    // Check if the result of the calculation is a valid number (not NaN)
                                    (isNaN(
                                      calculateTaxableAmt(
                                        calculateGrossAmt(
                                          indent.PO_qty,
                                          indent.Item_rate
                                        ),
                                        calculateDiscAmt(
                                          calculateGrossAmt(
                                            indent.PO_qty,
                                            indent.Item_rate
                                          ),
                                          indent.Disc_per
                                        )
                                      )
                                    )
                                      ? "" // If the result is not a valid number, display an empty string
                                      : (
                                        calculateTaxableAmt(
                                          calculateGrossAmt(
                                            indent.PO_qty,
                                            indent.Item_rate
                                          ),
                                          calculateDiscAmt(
                                            calculateGrossAmt(
                                              indent.PO_qty,
                                              indent.Item_rate
                                            ),
                                            indent.Disc_per
                                          )
                                        ) * exchange_rate
                                      ).toFixed(
                                        2
                                      )) // If it's valid, multiply by the exchange rate and display the result rounded to 2 decimal places
                                  }
                                </td>
                                {/* <td style={{
                                  minWidth: "90px",
                                  border: "1px solid black",
                                  backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center">
                                  123
                                </td> */}

                                {/* <td
  style={{
    minWidth: "90px",
    border: "1px solid black",
    backgroundColor: "#DCC4AA",
  }}
  className="text-center"
>
  {(() => {
    // Convert Freight/Insurance/Other to numbers safely
    const freight = parseFloat(Freight_amt) || 0;
    const insurance = parseFloat(Insurance_amt) || 0;
    const other = parseFloat(Oth_amt) || 0;
    const totalExtras = freight + insurance + other;

    // Calculate this row's net amount
    const rowNetAmount =
      Item_type === "Local"
        ? (
            calculateTaxableAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              calculateDiscAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                indent.Disc_per
              )
            ) +
            (indent.sgstAmt || 0) +
            (indent.cgstAmt || 0) +
            (indent.igstAmt || 0)
          )
        : Item_type === "Import"
        ? (
            calculateTaxableAmt(
              calculateGrossAmt(indent.PO_qty, indent.Item_rate),
              calculateDiscAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                indent.Disc_per
              )
            ) * exchange_rate
          )
        : 0;

    // Calculate Total Net Amount (same logic as footer)
    const totalNetAmt =
      Item_type === "Local"
        ? combinedData
            .filter((indent, i) =>
              selectedIndents.includes(`${indent.indent_no}-${i}-${indent.itemCd}`)
            )
            .reduce((total, indent) => {
              const taxableAmt = calculateTaxableAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                calculateDiscAmt(
                  calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                  indent.Disc_per
                )
              );
              return (
                total +
                taxableAmt +
                (indent.sgstAmt || 0) +
                (indent.cgstAmt || 0) +
                (indent.igstAmt || 0)
              );
            }, 0)
        : Item_type === "Import"
        ? combinedData
            .filter((indent, i) =>
              selectedIndents.includes(`${indent.indent_no}-${i}-${indent.itemCd}`)
            )
            .reduce((total, indent) => {
              const taxableAmt = calculateTaxableAmt(
                calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                calculateDiscAmt(
                  calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                  indent.Disc_per
                )
              );
              return total + taxableAmt * exchange_rate;
            }, 0)
        : 0;

    // Final proportional value
    const proportionalValue =
      totalNetAmt > 0 ? (totalExtras * rowNetAmount) / totalNetAmt : 0;

    return proportionalValue.toFixed(2);
  })()}
</td> */}

                                {/* <td
  style={{
    minWidth: "90px",
    border: "1px solid black",
    backgroundColor: "#DCC4AA",
  }}
  className="text-center"
>
  {(() => {
    const foundCost = itemCosts.find(
      (c) =>
        c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
    );
    return foundCost ? foundCost.itemCost.toFixed(2) : "0.00";
  })()}
</td> */}
                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {itemCosts.find(
                                    (c) => c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
                                  )?.itemCost.toFixed(2) || "0.00"}
                                </td>

                                {/* <td style={{
                                  minWidth: "90px",
                                  border: "1px solid black",
                                  backgroundColor: "#DCC4AA",
                                }}
                                  className="text-center">
                                  Actual Rate
                                </td> */}

                                <td
                                  style={{
                                    minWidth: "90px",
                                    border: "1px solid black",
                                    backgroundColor: "#DCC4AA",
                                  }}
                                  className="text-center"
                                >
                                  {(() => {
                                    const itemCost = itemCosts.find(
                                      (c) => c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
                                    )?.itemCost || 0;

                                    const actualRate =
                                      (parseFloat(indent.Item_rate) || 0) + (parseFloat(itemCost) || 0);

                                    // ✅ Also store this in the row (optional but useful for saving)
                                    indent.Actual_Rate = actualRate;

                                    return actualRate.toFixed(2);
                                  })()}
                                </td>

                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    marginRight: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "6px",
                      width: "250px",
                      marginBottom: "20px",
                    }}
                  >

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        <strong>Total Net_Amt:</strong>
                      </label>

                      {Item_type === "Local"
                        ? // When Item_type is 'Local', display the sum of taxable amount, SGST, CGST, and IGST
                        combinedData
                          .filter((indent, index) =>
                            selectedIndents.includes(
                              `${indent.indent_no}-${index}-${indent.itemCd}`
                            )
                          )
                          .reduce((total, indent) => {
                            const taxableAmt = calculateTaxableAmt(
                              calculateGrossAmt(
                                indent.PO_qty,
                                indent.Item_rate
                              ),
                              calculateDiscAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                indent.Disc_per
                              )
                            );
                            return (
                              total +
                              taxableAmt +
                              indent.sgstAmt +
                              indent.cgstAmt +
                              indent.igstAmt
                            );
                          }, 0)
                          .toFixed(2)
                        : // When Item_type is 'Import', display the calculated amount with exchange rate
                        Item_type === "Import" &&
                        combinedData
                          .filter((indent, index) =>
                            selectedIndents.includes(
                              `${indent.indent_no}-${index}-${indent.itemCd}`
                            )
                          )
                          .reduce((total, indent) => {
                            const taxableAmt = calculateTaxableAmt(
                              calculateGrossAmt(
                                indent.PO_qty,
                                indent.Item_rate
                              ),
                              calculateDiscAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                indent.Disc_per
                              )
                            );
                            const result = isNaN(taxableAmt)
                              ? "" // If the result is not a valid number, return an empty string
                              : (taxableAmt * exchange_rate).toFixed(2); // Multiply by exchange rate and return the result

                            return (
                              total + (isNaN(result) ? 0 : parseFloat(result))
                            ); // Add the result (if valid)
                          }, 0)
                          .toFixed(2)}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "6px",
                      width: "250px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        Freight amt:
                      </label>
                      <input
                        type="text"
                        name="Freight_amt"
                        value={Freight_amt}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          // Check if a decimal is entered
                          if (inputValue.includes(".")) {
                            // If decimal is present, ensure only two digits after the decimal
                            let parts = inputValue.split(".");
                            if (parts[1] && parts[1].length > 2) {
                              // Limit the digits to 2 after the decimal
                              e.target.value =
                                parts[0] + "." + parts[1].slice(0, 2);
                            }
                          }
                          setFreightAmt(e.target.value);
                          calculateTotalAmountAndDetails();
                        }}
                        onBlur={(e) => {
                          let value = e.target.value;
                          if (value && !value.includes(".")) {
                            value = parseFloat(value).toFixed(2);
                          } else if (value) {
                            value = parseFloat(value).toFixed(2);
                          }
                          e.target.value = value;
                          setFreightAmt(value);
                          calculateTotalAmountAndDetails();
                        }}

                        autoComplete="off"

                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          textAlign: "right",
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          minWidth: "80px",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength={10}
                        pattern="[A-Za-z0-9]+"
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        Insurace amt:
                      </label>
                      <input
                        type="text"
                        name="Insurance_amt"
                        value={Insurance_amt}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          // Check if a decimal is entered
                          if (inputValue.includes(".")) {
                            // If decimal is present, ensure only two digits after the decimal
                            let parts = inputValue.split(".");
                            if (parts[1] && parts[1].length > 2) {
                              // Limit the digits to 2 after the decimal
                              e.target.value =
                                parts[0] + "." + parts[1].slice(0, 2);
                            }
                          }
                          setInsuranceAmt(e.target.value);
                          calculateTotalAmountAndDetails();
                        }}
                        onBlur={(e) => {
                          let value = e.target.value;
                          if (value && !value.includes(".")) {
                            value = parseFloat(value).toFixed(2);
                          } else if (value) {
                            value = parseFloat(value).toFixed(2);
                          }
                          e.target.value = value;
                          setInsuranceAmt(value);
                          calculateTotalAmountAndDetails();
                        }}
                        autoComplete="off"

                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          textAlign: "right",
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          minWidth: "80px",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength={10}
                        pattern="[A-Za-z0-9]+"
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        Other amt:
                      </label>
                      <input
                        type="text"
                        name="Oth_amt"
                        value={Oth_amt}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          // Check if a decimal is entered
                          if (inputValue.includes(".")) {
                            // If decimal is present, ensure only two digits after the decimal
                            let parts = inputValue.split(".");
                            if (parts[1] && parts[1].length > 2) {
                              // Limit the digits to 2 after the decimal
                              e.target.value =
                                parts[0] + "." + parts[1].slice(0, 2);
                            }
                          }
                          setOthAmt(e.target.value);
                          calculateTotalAmountAndDetails();
                        }}
                        onBlur={(e) => {
                          let value = e.target.value;
                          if (value && !value.includes(".")) {
                            value = parseFloat(value).toFixed(2);
                          } else if (value) {
                            value = parseFloat(value).toFixed(2);
                          }
                          e.target.value = value;
                          setOthAmt(value);
                          calculateTotalAmountAndDetails();
                        }}
                        autoComplete="off"

                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          textAlign: "right",
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          minWidth: "80px",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength={10}
                        pattern="[A-Za-z0-9]+"
                      />
                    </div>

                    {/**others roundes amount */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        Rounded amtt:
                      </label>
                      <input
                        type="text"
                        name="round_amt"
                        value={round_amt}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          // Check if a decimal is entered
                          if (inputValue.includes(".")) {
                            // If decimal is present, ensure only two digits after the decimal
                            let parts = inputValue.split(".");
                            if (parts[1] && parts[1].length > 2) {
                              // Limit the digits to 2 after the decimal
                              e.target.value =
                                parts[0] + "." + parts[1].slice(0, 2);
                            }
                          }
                          setRoundAmt(e.target.value);
                          calculateTotalAmountAndDetails();
                        }}
                        onBlur={(e) => {
                          let value = e.target.value;
                          if (value && !value.includes(".")) {
                            value = parseFloat(value).toFixed(2);
                          } else if (value) {
                            value = parseFloat(value).toFixed(2);
                          }
                          e.target.value = value;
                          setRoundAmt(value);
                          calculateTotalAmountAndDetails();
                        }}
                        autoComplete="off"

                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        style={{
                          textAlign: "right",
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          minWidth: "80px",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                        maxLength={10}
                        pattern="[A-Za-z0-9]+"
                      />
                    </div>
                    {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        Total amt:
                      </label>
                      <input
                        type="text"
                        name="Total_amt"
                        value={Total_amt || 0}
                        style={{
                          textAlign: "right",
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          minWidth: "80px",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        Total amt:
                      </label>
                      <input
                        type="text"
                        name="Total_amt"
                        value={(
                          // Calculate Net_amt dynamically
                          (Item_type === "Local"
                            ? combinedData
                              .filter((indent, index) =>
                                selectedIndents.includes(
                                  `${indent.indent_no}-${index}-${indent.itemCd}`
                                )
                              )
                              .reduce((total, indent) => {
                                const taxableAmt = calculateTaxableAmt(
                                  calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                                  calculateDiscAmt(
                                    calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                                    indent.Disc_per
                                  )
                                );
                                return total + taxableAmt + indent.sgstAmt + indent.cgstAmt + indent.igstAmt;
                              }, 0)
                            : Item_type === "Import"
                              ? combinedData
                                .filter((indent, index) =>
                                  selectedIndents.includes(
                                    `${indent.indent_no}-${index}-${indent.itemCd}`
                                  )
                                )
                                .reduce((total, indent) => {
                                  const taxableAmt = calculateTaxableAmt(
                                    calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                                    calculateDiscAmt(
                                      calculateGrossAmt(indent.PO_qty, indent.Item_rate),
                                      indent.Disc_per
                                    )
                                  );
                                  const result = isNaN(taxableAmt)
                                    ? 0
                                    : taxableAmt * exchange_rate;
                                  return total + result;
                                }, 0)
                              : 0) +
                          // Add other amounts
                          parseFloat(Freight_amt || 0) +
                          parseFloat(Insurance_amt || 0) +
                          parseFloat(Oth_amt || 0) +
                          parseFloat(round_amt || 0)
                        ).toFixed(2)}
                        readOnly
                        style={{
                          textAlign: "right",
                          border: "none",
                          borderLeft: "2px solid #D1D5DB",
                          minWidth: "80px",
                          outline: "none",
                          backgroundColor: "transparent",
                        }}
                      />
                    </div>


                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {showEditformm && (
          <div style={{ marginTop: "22px" }}>
            <div
              className="p-1"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "end" }}>
                  <label style={{ marginRight: "95px", color: "darkblue" }}>
                    PO No :
                  </label>
                  {/* <input type="text" placeholder="Search by P O No"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{ width: '60%', padding: '4px', marginRight: '10px', backgroundColor: '#dbc4a9', border: '1px solid #ccc', }} /> */}

                  <Select
                    options={poOptions}
                    value={poOptions.find((option) => option.value === PO_no)}
                    onChange={handlePOSelectChangee}
                    placeholder="Select PO No"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "50%", // Set the width of the container
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999, // Make sure the dropdown appears above other elements
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: "100%", // Match the width of the dropdown with the container

                        overflowY: "auto", // Add a scrollbar if the content exceeds the maxHeight
                      }),
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        height: "35px", // Control the height of the input box
                        padding: "4px", // Adjust padding for better appearance
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: "black", // Adjust the color of the selected value text
                      }),
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "86px", color: "darkblue" }}>
                    PO Type:
                  </label>
                  <select
                    name="Po_Type"
                    value={Po_Type}
                    onChange={(e) => setPoType(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  >
                    <option value="CAPX">CAPX</option>
                    <option value="OPEX">OPEX</option>
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "42px", color: "darkblue" }}>
                    Delivery Terms:
                  </label>
                  <input
                    type="text"
                    name="Deli_terms"
                    value={Deli_terms}
                    maxLength={20}
                    pattern="[A-Za-z0-9]+"
                    onChange={(e) => setDeliTerms(e.target.value)}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "67px", color: "darkblue" }}>
                    Delivery Dt:
                  </label>
                  <input
                    type="date"
                    name="Deli_dt"
                    value={deliveryDate}
                    onChange={(e) => setDeliveryDate(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "32px", color: "darkblue" }}>
                    Destination GST:
                  </label>
                  <input
                    readOnly
                    name="Des_gst"
                    value={Des_gst}
                    maxLength={12}
                    pattern="[A-Za-z0-9]+"
                    onChange={handleDesGstChange}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "24px", color: "darkblue" }}>
                    Destination State:
                  </label>
                  <input
                    type="text"
                    name="Des_state_cd"
                    value={getStateName(Des_state_cd)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
              </div>

              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "65px", color: "darkblue" }}>
                    P O Dt:
                  </label>
                  <input
                    type="date"
                    name="PO_Dt"
                    value={PO_Dt || ""}
                    onChange={(e) => setPoDate(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "42px", color: "darkblue" }}>
                    Item Type:
                  </label>
                  <select
                    name="Item_type"
                    value={Item_type}
                    onChange={(e) => setItemType(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  >
                    <option value="Import">Import</option>
                    <option value="Local">Local</option>
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "4px", color: "darkblue" }}>
                    Payment Terms:
                  </label>
                  <input
                    type="text"
                    name="Pay_terms"
                    value={Pay_terms}
                    maxLength={20}
                    pattern="[A-Za-z0-9]+"
                    onChange={(e) => setPayTerms(e.target.value)}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>



                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "47px", color: "darkblue" }}>
                    Currency:
                  </label>
                  <select
                    name="currency"
                    value={currency}
                    onChange={(e) => setCurrency(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={Item_type === "Local"} // Disable if Local is selected
                  >
                    {Item_type === "Import" ? (
                      <>
                        <option value="USD">USD</option>
                        <option value="EURO">EURO</option>
                      </>
                    ) : (
                      <option value="INR">INR</option>
                    )}
                  </select>
                </div>
                {Item_type === "Import" && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label
                      style={{ marginRight: "7px", color: "darkblue" }}
                    >
                      Exchange Rate:
                    </label>
                    <input
                      type="text"
                      name="exchange_rate"
                      value={exchange_rate}
                      onChange={(e) => setExchangeRate(e.target.value)}
                      style={{
                        border: "none",
                        borderLeft: "2px solid #D1D5DB",
                        padding: "2px",
                        width: "50%",
                        outline: "none",
                        backgroundColor: "transparent",
                      }}

                    />
                  </div>
                )}
              </div>



              <div>
                {/* <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '44px', color: 'darkblue' }}>Supplier:</label>
                  <select
                   onChange={handleSupplierChange} 
                   readOnly 
                   value={Supp_id} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '2px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} >
                    <option value="">Select</option>
                    {suppliers.map((supplier) => (<option key={supplier.Supp_cd} value={supplier.Supp_cd}>{supplier.Supp_Nm}</option>))}
                  </select>
                </div> */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "44px", color: "darkblue" }}>
                    Supplier:
                  </label>
                  <div
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      backgroundColor: "transparent",
                      color: "black",
                      fontSize: "14px",
                      paddingLeft: "5px",
                    }}
                  >
                    {Supp_id
                      ? suppliers.find(
                        (supplier) => supplier.Supp_cd === Supp_id
                      )?.Supp_Nm
                      : "Select"}
                  </div>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "22px", color: "darkblue" }}>
                    Credit Days:
                  </label>
                  <input
                    type="number"
                    name="Credit_days"
                    value={Credit_days}
                    onChange={handleCreditDaysChange}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "13px", color: "darkblue" }}>
                    Supplier GST:
                  </label>
                  <input
                    type="text"
                    name="Supp_gst"
                    value={supplier ? supplier.Gst_No : ""}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "6px", color: "darkblue" }}>
                    Supplier State:
                  </label>
                  <input
                    type="text"
                    name="Supp_state_cd"
                    value={supplier ? extractStateFromGST(supplier.Gst_No) : ""}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
              </div>
            </div>

            <div
              className="table-responsive"
              style={{ overflowY: "auto", maxHeight: "240px" }}
            >
              <div>
                <table
                  className="table  "
                  style={{
                    minWidth: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Sl
                      </th>
                      <th
                        className="text-center"
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Code
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Description
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        UOM
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        HSN CODE
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        GST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Indent Location
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Indent No
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Indent Qty
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        PO Qty
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Rate
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Gross Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Disc %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Disc Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Taxable amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Gross Amt(FC)
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        SGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        SGST AMT
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        CGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        CGST Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        IGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        IGST Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        UGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        UGST Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Net Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Cost
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Actually Rate
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleRows.map((indent, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.itemCd}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.itemDesc}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.UOM}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Hsn_code}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.GST_per}
                        </td>
                        {/* <td style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Indent_loc}</td> */}
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {locationDescMapping[indent.Indent_loc] ||
                            indent.Indent_loc}{" "}
                          {/* Fallback to Indent_loc if no mapping found */}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Indent_no}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.qty}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          <input
                            type="text"
                            style={{
                              minWidth: "90px",
                              border: "1px solid #DCC4AA",
                              backgroundColor: "#DCC4AA",
                            }}
                            className="form-control"
                            value={indent.PO_qty || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes(".")) {
                                // If decimal is present, ensure only two digits after the decimal
                                let parts = inputValue.split(".");
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value =
                                    parts[0] + "." + parts[1].slice(0, 2);
                                }
                              }
                              handleEditInputChange(
                                e,
                                indent.Indent_no,
                                "PO_qty",
                                index
                              );
                            }}
                            disabled={formMode === "view"}
                            maxLength={10}
                            pattern="[A-Za-z0-9]+"
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          <input
                            type="text"
                            style={{
                              minWidth: "90px",
                              border: "1px solid #DCC4AA",
                              backgroundColor: "#DCC4AA",
                            }}
                            className="form-control"
                            value={indent.Item_rate || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes(".")) {
                                // If decimal is present, ensure only two digits after the decimal
                                let parts = inputValue.split(".");
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value =
                                    parts[0] + "." + parts[1].slice(0, 2);
                                }
                              }
                              handleEditInputChange(
                                e,
                                indent.Indent_no,
                                "Item_rate",
                                index
                              );
                            }}
                            disabled={formMode === "view"}
                            maxLength={10}
                            pattern="[A-Za-z0-9]+"
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {isNaN(
                            calculateGrossAmt(indent.PO_qty, indent.Item_rate)
                          )
                            ? ""
                            : calculateGrossAmt(
                              indent.PO_qty,
                              indent.Item_rate
                            )}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          <input
                            type="text"
                            value={indent.Disc_per || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes(".")) {
                                let parts = inputValue.split(".");
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value =
                                    parts[0] + "." + parts[1].slice(0, 2);
                                }
                              }
                              handleEditInputChange(
                                e,
                                indent.Indent_no,
                                "Disc_per",
                                index
                              );
                            }}
                            style={{
                              minWidth: "90px",
                              border: "1px solid #DCC4AA",
                              backgroundColor: "#DCC4AA",
                            }}
                            className="form-control"
                            disabled={formMode === "view"}
                            maxLength={10}
                            pattern="[A-Za-z0-9]+"
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Disc_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {isNaN(
                            calculateTaxableAmt(
                              calculateGrossAmt(
                                indent.PO_qty,
                                indent.Item_rate
                              ),
                              calculateDiscAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                indent.Disc_per
                              )
                            )
                          )
                            ? ""
                            : calculateTaxableAmt(
                              calculateGrossAmt(
                                indent.PO_qty,
                                indent.Item_rate
                              ),
                              calculateDiscAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                indent.Disc_per
                              )
                            )}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {
                            // Check if the result of the calculation is a valid number (not NaN)
                            isNaN(
                              calculateTaxableAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                calculateDiscAmt(
                                  calculateGrossAmt(
                                    indent.PO_qty,
                                    indent.Item_rate
                                  ),
                                  indent.Disc_per
                                )
                              )
                            )
                              ? "" // If the result is not a valid number, display an empty string
                              : (
                                calculateTaxableAmt(
                                  calculateGrossAmt(
                                    indent.PO_qty,
                                    indent.Item_rate
                                  ),
                                  calculateDiscAmt(
                                    calculateGrossAmt(
                                      indent.PO_qty,
                                      indent.Item_rate
                                    ),
                                    indent.Disc_per
                                  )
                                ) * exchange_rate
                              ).toFixed(2) // If it's valid, multiply by 22 and display the result rounded to 2 decimal places
                          }
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Sgst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Sgst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Cgst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Cgst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Igst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Igst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Ugst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Ugst_amt}
                        </td>
                        {/* <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Net_amt}
                        </td> */}
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {Item_type?.toLowerCase() === "import" ? indent?.grpss_amt_fce ?? "" : indent?.Net_amt ?? ""}
                        </td>

                        {/* <td
  style={{
    minWidth: "90px",
    border: "1px solid black",
    backgroundColor: "#DCC4AA",
  }}
  className="text-center"
>
  {/* {itemCosts.find(
    (c) => c.indent_no === indent.indent_no && c.itemCd === indent.itemCd
  )?.itemCost.toFixed(2) || "0.00"} *
  {indent.itemCost}
</td> */}

                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {(() => {
                            const baseAmt =
                              Item_type?.toLowerCase() === "import"
                                ? indent?.grpss_amt_fce ?? 0
                                : indent?.Net_amt ?? 0;
                            const additionalAmt =
                              Number(Freight_amt || 0) + Number(Insurance_amt || 0) + Number(Oth_amt || 0);
                            const divisor = Number(Total_amt || 0) - Number(Freight_amt || 0) - Number(Insurance_amt || 0) -
                              Number(Oth_amt || 0) -
                              Number(round_amt || 0);

                            const calculatedCost =
                              totalNetAmtt !== 0 ? (additionalAmt * baseAmt) / totalNetAmtt : 0;

                            return calculatedCost.toFixed(2);
                          })()}
                        </td>

                        {/* <td style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center">
                        
                        {indent.Actual_Rate}
                        </td> */}
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {(() => {
                            // 🔹 Calculate item cost as per your existing logic
                            const baseAmt =
                              Item_type?.toLowerCase() === "import"
                                ? indent?.grpss_amt_fce ?? 0
                                : indent?.Net_amt ?? 0;
                            const additionalAmt =
                              Number(Freight_amt || 0) + Number(Insurance_amt || 0) + Number(Oth_amt || 0);
                            const divisor =
                              Number(Total_amt || 0) -
                              Number(Freight_amt || 0) -
                              Number(Insurance_amt || 0) -
                              Number(Oth_amt || 0) -
                              Number(round_amt || 0);

                            const calculatedCost = totalNetAmtt !== 0 ? (additionalAmt * baseAmt) / totalNetAmtt : 0;

                            // 🔹 Get the item rate (entered by user)
                            const itemRate = parseFloat(indent.Item_rate) || 0;

                            // 🔹 Calculate Actual Rate
                            const actualRate =
                              itemRate === 0 ? calculatedCost : itemRate + calculatedCost;

                            // 🔹 Update indent object so it carries this value
                            indent.Actual_Rate = actualRate.toFixed(2);

                            return actualRate.toFixed(2);
                          })()}
                        </td>




                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                marginRight: "10px",
              }}
            >
              {/* <p className='mb-0' style={{ textAlign: 'right', marginRight: '10px',padding:'10px' }}><strong>Total Net_Amt:</strong>{Net_amt}</p> */}

              {formMode === "view" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "6px",
                    width: "250px",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <label
                      style={{
                        width: "140px",
                        textAlign: "left",
                        color: "darkblue",
                      }}
                    >
                      <strong>Total Net_Amt:</strong>
                    </label>

                    {/* {(
                     Net_amt
                    ).toFixed(2)} */}
                    {/* {Net_amt} */}
                    {/* {(
                      Total_amt -
                      Freight_amt -
                      Insurance_amt -
                      Oth_amt -
                      round_amt
                      //Net_amt
                    ).toFixed(2)} */}
                    {totalNetAmtt}
                  </div>
                </div>
              ) : (
                formMode === "edit" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "6px",
                      width: "250px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          width: "140px",
                          textAlign: "left",
                          color: "darkblue",
                        }}
                      >
                        <strong>Total Net_Amt:</strong>
                      </label>

                      {/* {(
                        Total_amt -
                        Freight_amt -
                        Insurance_amt -
                        Oth_amt -
                        round_amt
                        //Net_amt
                      ).toFixed(2)} */}
                      {/* {Net_amt} */}
                      {totalNetAmtt}
                    </div>
                  </div>
                )
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "6px",
                  width: "250px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Freight amt v:
                  </label>
                  <input
                    type="number"
                    // value={(Freight_amt).toFixed(2)}
                    // value={(typeof Freight_amt === "number"? Freight_amt: 0).toFixed(2)}
                    value={Freight_amt ?? ""} // show empty if no value

                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setFreightAmt(e.target.value);
                    }}
                    onBlur={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = parseFloat(value).toFixed(2); // convert to .00
                      }
                      setFreightAmt(value);
                    }}

                    // style={{ minWidth: '80px', textAlign: 'right' }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Insurance amt:
                  </label>
                  <input
                    type="number"
                    // value={(Insurance_amt).toFixed(2)}
                    // value={(typeof Insurance_amt === "number"
                    //   ? Insurance_amt
                    //   : 0
                    // ).toFixed(2)}
                    value={Insurance_amt ?? ""}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setInsuranceAmt(e.target.value);
                    }}
                    onBlur={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = parseFloat(value).toFixed(2); // convert to .00
                      }
                      setInsuranceAmt(value);
                    }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "150px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Other amt:
                  </label>
                  <input
                    type="number"
                    // value={(Oth_amt).toFixed(2)}
                    // value={(typeof Oth_amt === "number" ? Oth_amt : 0).toFixed(
                    //   2
                    // )}
                    value={Oth_amt ?? ""}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setOthAmt(e.target.value);
                    }}

                    onBlur={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = parseFloat(value).toFixed(2); // convert to .00
                      }
                      setOthAmt(value);
                    }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>



                {/*** this is edit and view  Round_amt */}


                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "150px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Round amt:
                  </label>
                  <input
                    type="number"
                    // value={(round_amt).toFixed(2)}
                    // value={(typeof round_amt === "number" ? round_amt : 0).toFixed(
                    //   2
                    // )}
                    value={round_amt ?? ""}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setRoundAmt(e.target.value);
                    }}
                    onBlur={(e) => {
                      let value = e.target.value;
                      if (value !== "") {
                        value = parseFloat(value).toFixed(2); // convert to .00
                      }
                      setRoundAmt(value);
                    }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>
                {/*** this is end for round amt */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    <strong>Total amt:</strong>
                  </label>
                  {/* <span style={{ minWidth: '80px', textAlign: 'right' }}><strong>
                    {Total_amt}
                  </strong></span> */}
                  {/* <span style={{ minWidth: "80px", textAlign: "right" }}>
                    <strong>
                      {(typeof Total_amt === "number" && !isNaN(Total_amt)
                        ? Total_amt
                        : 0
                      ).toFixed(2)}
                    </strong>
                  </span> */}
                  <span style={{ minWidth: "80px", textAlign: "right" }}>
                    <strong>
                      {(
                        // if user entered any of the 4 fields, calculate new total
                        (parseFloat(Freight_amt) ||
                          parseFloat(Insurance_amt) ||
                          parseFloat(Oth_amt) ||
                          parseFloat(round_amt))
                          ? (
                            (parseFloat(totalNetAmtt) || 0) +
                            (parseFloat(Freight_amt) || 0) +
                            (parseFloat(Insurance_amt) || 0) +
                            (parseFloat(Oth_amt) || 0) +
                            (parseFloat(round_amt) || 0)
                          )
                          : (parseFloat(Total_amt) || 0) // otherwise keep existing Total_amt from DB
                      ).toFixed(2)}
                    </strong>
                  </span>

                </div>

                {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}><strong>Total amt:</strong></label>
                  <span style={{ minWidth: '80px', textAlign: 'right' }}>
                    <strong>
                      {formMode === 'view' ?
                        `${Freight_amt} + ${Insurance_amt} + ${Oth_amt} = ${Total_amt}`
                        : Total_amt}
                    </strong>
                  </span>
                </div> */}
              </div>
            </div>
          </div>
        )}

        {showApproveForm && (
          <div disabled={formMode === "view"} style={{ marginTop: "22px" }}>
            <div
              className="p-1"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "end" }}>
                  <label style={{ marginRight: "95px", color: "darkblue" }}>
                    PO No :
                  </label>
                  {/* <input type="text" placeholder="Search by P O No"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{ width: '60%', padding: '4px', marginRight: '10px', backgroundColor: '#dbc4a9', border: '1px solid #ccc', }} />

                  <select name="PO_no" value={PO_no} onChange={handlePOSelectChangee} style={{ width: '20%', padding: '4px', backgroundColor: '#dbc4a9', border: '1px solid #ccc', }} >
                    <option value=""></option>
                    {poNumbers.map((poNumber, index) => (
                      <option key={index} value={poNumber}>{poNumber}</option>))}
                  </select> */}
                  <Select
                    options={poOptions1}
                    value={poOptions1.find((option) => option.value === PO_no)}
                    onChange={handlePOSelectChangee1}
                    placeholder="Search PO No"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "50%", // Set the width of the container
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999, // Make sure the dropdown appears above other elements
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: "80%", // Match the width of the dropdown with the container
                        //maxHeight: '100px', // Limit the height of the dropdown
                        overflowY: "auto", // Add a scrollbar if the content exceeds the maxHeight
                      }),
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        height: "35px", // Control the height of the input box
                        padding: "4px", // Adjust padding for better appearance
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: "black", // Adjust the color of the selected value text
                      }),
                    }}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "86px", color: "darkblue" }}>
                    PO Type:
                  </label>
                  <select
                    name="Po_Type"
                    value={Po_Type}
                    disabled={formMode === "approve"}
                    onChange={(e) => setPoType(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  >
                    <option value="CAPX">CAPX</option>
                    <option value="OPEX">OPEX</option>
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "42px", color: "darkblue" }}>
                    Delivery Terms:
                  </label>
                  <input
                    type="text"
                    name="Deli_terms"
                    value={Deli_terms}
                    maxLength={20}
                    pattern="[A-Za-z0-9]+"
                    onChange={(e) => setDeliTerms(e.target.value)}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "67px", color: "darkblue" }}>
                    Delivery Dt:
                  </label>
                  <input
                    type="date"
                    name="Deli_dt"
                    value={deliveryDate}
                    onChange={(e) => setDeliveryDate(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "32px", color: "darkblue" }}>
                    Destination GST:
                  </label>
                  <input
                    type="text"
                    name="Des_gst"
                    value={Des_gst}
                    maxLength={12}
                    pattern="[A-Za-z0-9]+"
                    onChange={handleDesGstChange}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "24px", color: "darkblue" }}>
                    Destination State:
                  </label>
                  <input
                    type="text"
                    name="Des_state_cd"
                    value={getStateName(Des_state_cd)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
              </div>

              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "65px", color: "darkblue" }}>
                    P O Dt:
                  </label>
                  <input
                    type="date"
                    name="PO_Dt"
                    value={PO_Dt || ""}
                    onChange={(e) => setPoDate(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "42px", color: "darkblue" }}>
                    Item Type:
                  </label>
                  <select
                    name="Item_type"
                    value={Item_type}
                    disabled={formMode === "approve"}
                    onChange={(e) => setItemType(e.target.value)}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  >
                    <option value="Import">Import</option>
                    <option value="Local">Local</option>
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "4px", color: "darkblue" }}>
                    Payment Terms:
                  </label>
                  <input
                    type="text"
                    name="Pay_terms"
                    value={Pay_terms}
                    maxLength={20}
                    pattern="[A-Za-z0-9]+"
                    onChange={(e) => setPayTerms(e.target.value)}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
              </div>

              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "44px", color: "darkblue" }}>
                    Supplier:
                  </label>
                  <select
                    onChange={handleSupplierChange}
                    disabled={formMode === "approve"}
                    value={Supp_id}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                  >
                    <option value="">Select</option>
                    {suppliers.map((supplier) => (
                      <option key={supplier.Supp_cd} value={supplier.Supp_cd}>
                        {supplier.Supp_Nm}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "22px", color: "darkblue" }}>
                    Credit Days:
                  </label>
                  <input
                    type="number"
                    name="Credit_days"
                    value={Credit_days}
                    onChange={handleCreditDaysChange}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "13px", color: "darkblue" }}>
                    Supplier GST:
                  </label>
                  <input
                    type="text"
                    name="Supp_gst"
                    value={supplier ? supplier.Gst_No : ""}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label style={{ marginRight: "6px", color: "darkblue" }}>
                    Supplier State:
                  </label>
                  <input
                    type="text"
                    name="Supp_state_cd"
                    value={supplier ? extractStateFromGST(supplier.Gst_No) : ""}
                    style={{
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      padding: "2px",
                      width: "50%",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
              </div>
            </div>

            <div
              className="table-responsive"
              style={{ overflowY: "auto", maxHeight: "240px" }}
            >
              <div>
                <table
                  className="table  "
                  style={{
                    minWidth: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Sl
                      </th>
                      <th
                        className="text-center"
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Code
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Description
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        UOM
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        HSN CODE
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        GST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Indent Location
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Indent No
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Indent Qty
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        PO Qty
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Item Rate
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Gross Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Disc %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Disc Amt
                      </th>

                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Taxable amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        SGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        SGST AMT
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        CGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        CGST Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        IGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        IGST Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        UGST %
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        UGST Amt
                      </th>
                      <th
                        className="text-center "
                        style={{
                          border: "1px solid black",
                          backgroundColor: "#DCC4AA",
                        }}
                      >
                        Net Amt
                      </th>
                      <th
                        clssName="text-center"
                        style={{ border: "1px solid black", backgroundColor: "#DCC4AA" }}>
                        Item Cost
                      </th>
                      <th
                        clssName="text-center"
                        style={{ border: "1px solid black", backgroundColor: "#DCC4AA" }}>
                        Actual Rate
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleRows.map((indent, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.itemCd}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.itemDesc}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.UOM}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Hsn_code}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.GST_per}
                        </td>
                        {/* <td style={{ border: '1px solid black', backgroundColor: '#DCC4AA' }} className="text-center">{indent.Indent_loc}</td> */}
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {locationDescMapping[indent.Indent_loc] ||
                            indent.Indent_loc}{" "}
                          {/* Fallback to Indent_loc if no mapping found */}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Indent_no}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.qty}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          <input
                            type="text"
                            style={{
                              minWidth: "90px",
                              border: "1px solid #DCC4AA",
                              backgroundColor: "#DCC4AA",
                            }}
                            className="form-control"
                            value={indent.PO_qty || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes(".")) {
                                // If decimal is present, ensure only two digits after the decimal
                                let parts = inputValue.split(".");
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value =
                                    parts[0] + "." + parts[1].slice(0, 2);
                                }
                              }
                              handleEditInputChange(
                                e,
                                indent.Indent_no,
                                "PO_qty",
                                index
                              );
                            }}
                            disabled={formMode === "approve"}
                            maxLength={10}
                            pattern="[A-Za-z0-9]+"
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          <input
                            type="text"
                            style={{
                              minWidth: "90px",
                              border: "1px solid #DCC4AA",
                              backgroundColor: "#DCC4AA",
                            }}
                            className="form-control"
                            value={indent.Item_rate || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes(".")) {
                                // If decimal is present, ensure only two digits after the decimal
                                let parts = inputValue.split(".");
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value =
                                    parts[0] + "." + parts[1].slice(0, 2);
                                }
                              }
                              handleEditInputChange(
                                e,
                                indent.Indent_no,
                                "Item_rate",
                                index
                              );
                            }}
                            disabled={formMode === "approve"}
                            maxLength={10}
                            pattern="[A-Za-z0-9]+"
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {isNaN(
                            calculateGrossAmt(indent.PO_qty, indent.Item_rate)
                          )
                            ? ""
                            : calculateGrossAmt(
                              indent.PO_qty,
                              indent.Item_rate
                            )}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          <input
                            type="text"
                            value={indent.Disc_per || ""}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              // Check if a decimal is entered
                              if (inputValue.includes(".")) {
                                let parts = inputValue.split(".");
                                if (parts[1] && parts[1].length > 2) {
                                  // Limit the digits to 2 after the decimal
                                  e.target.value =
                                    parts[0] + "." + parts[1].slice(0, 2);
                                }
                              }
                              handleEditInputChange(
                                e,
                                indent.Indent_no,
                                "Disc_per",
                                index
                              );
                            }}
                            style={{
                              minWidth: "90px",
                              border: "1px solid #DCC4AA",
                              backgroundColor: "#DCC4AA",
                            }}
                            className="form-control"
                            disabled={formMode === "approve"}
                            maxLength={10}
                            pattern="[A-Za-z0-9]+"
                          />
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Disc_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {isNaN(
                            calculateTaxableAmt(
                              calculateGrossAmt(
                                indent.PO_qty,
                                indent.Item_rate
                              ),
                              calculateDiscAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                indent.Disc_per
                              )
                            )
                          )
                            ? ""
                            : calculateTaxableAmt(
                              calculateGrossAmt(
                                indent.PO_qty,
                                indent.Item_rate
                              ),
                              calculateDiscAmt(
                                calculateGrossAmt(
                                  indent.PO_qty,
                                  indent.Item_rate
                                ),
                                indent.Disc_per
                              )
                            )}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Sgst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Sgst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Cgst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Cgst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Igst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Igst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Ugst_per}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Ugst_amt}
                        </td>
                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {indent.Net_amt}
                        </td>

                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {(() => {
                            const baseAmt =
                              Item_type?.toLowerCase() === "import"
                                ? indent?.grpss_amt_fce ?? 0
                                : indent?.Net_amt ?? 0;
                            const additionalAmt =
                              Number(Freight_amt || 0) +
                              Number(Insurance_amt || 0) +
                              Number(Oth_amt || 0);
                            const divisor =
                              Number(Total_amt || 0) -
                              Number(Freight_amt || 0) -
                              Number(Insurance_amt || 0) -
                              Number(Oth_amt || 0) -
                              Number(round_amt || 0);

                            const calculatedCost =
                              divisor !== 0 ? (additionalAmt * baseAmt) / divisor : 0;

                            return calculatedCost.toFixed(2);
                          })()}
                        </td>

                        <td
                          style={{
                            minWidth: "90px",
                            border: "1px solid black",
                            backgroundColor: "#DCC4AA",
                          }}
                          className="text-center"
                        >
                          {(() => {
                            // 🔹 Calculate item cost as per your existing logic
                            const baseAmt =
                              Item_type?.toLowerCase() === "import"
                                ? indent?.grpss_amt_fce ?? 0
                                : indent?.Net_amt ?? 0;
                            const additionalAmt =
                              Number(Freight_amt || 0) + Number(Insurance_amt || 0) + Number(Oth_amt || 0);
                            const divisor =
                              Number(Total_amt || 0) -
                              Number(Freight_amt || 0) -
                              Number(Insurance_amt || 0) -
                              Number(Oth_amt || 0) -
                              Number(round_amt || 0);

                            const calculatedCost = divisor !== 0 ? (additionalAmt * baseAmt) / divisor : 0;

                            // 🔹 Get the item rate (entered by user)
                            const itemRate = parseFloat(indent.Item_rate) || 0;

                            // 🔹 Calculate Actual Rate
                            const actualRate =
                              itemRate === 0 ? calculatedCost : itemRate + calculatedCost;

                            // 🔹 Update indent object so it carries this value
                            indent.Actual_Rate = actualRate.toFixed(2);

                            return actualRate.toFixed(2);
                          })()}
                        </td>


                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                marginRight: "10px",
              }}
            >
              {/* <p className='mb-0' style={{ textAlign: 'right', marginRight: '10px',padding:'10px' }}><strong>Total Net_Amt:</strong>{Net_amt}</p> */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "6px",
                  width: "250px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    <strong>Total Net_Amt:</strong>
                  </label>
                  {(Total_amt - Freight_amt - Insurance_amt - Oth_amt).toFixed(
                    2
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "6px",
                  width: "250px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Freight amt:
                  </label>
                  <input
                    type="number"
                    // value={(Freight_amt).toFixed(2)}
                    value={(typeof Freight_amt === "number"
                      ? Freight_amt
                      : 0
                    ).toFixed(2)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setFreightAmt(e.target.value);
                    }}
                    // style={{ minWidth: '80px', textAlign: 'right' }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Insurance amt:
                  </label>
                  <input
                    type="number"
                    //value={(Insurance_amt).toFixed(2)}
                    value={(typeof Insurance_amt === "number"
                      ? Insurance_amt
                      : 0
                    ).toFixed(2)}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setInsuranceAmt(e.target.value);
                    }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Other amt:
                  </label>
                  <input
                    type="number"
                    // value={(Oth_amt).toFixed(2)}
                    value={(typeof Oth_amt === "number" ? Oth_amt : 0).toFixed(
                      2
                    )}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setOthAmt(e.target.value);
                    }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "approve"}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "150px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    Round amt:
                  </label>
                  <input
                    type="number"
                    // value={(round_amt).toFixed(2)}
                    value={(typeof round_amt === "number" ? round_amt : 0).toFixed(
                      2
                    )}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Check if a decimal is entered
                      if (inputValue.includes(".")) {
                        // If decimal is present, ensure only two digits after the decimal
                        let parts = inputValue.split(".");
                        if (parts[1] && parts[1].length > 2) {
                          // Limit the digits to 2 after the decimal
                          e.target.value =
                            parts[0] + "." + parts[1].slice(0, 2);
                        }
                      }
                      setRoundAmt(e.target.value);
                    }}
                    style={{
                      textAlign: "right",
                      border: "none",
                      borderLeft: "2px solid #D1D5DB",
                      minWidth: "80px",
                      outline: "none",
                      backgroundColor: "transparent",
                    }}
                    disabled={formMode === "view"}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      width: "140px",
                      textAlign: "left",
                      color: "darkblue",
                    }}
                  >
                    <strong>Total amt:</strong>
                  </label>
                  <span style={{ minWidth: "80px", textAlign: "right" }}>
                    <strong>
                      {/* {Total_amt} */}
                      {(typeof Total_amt === "number" && !isNaN(Total_amt)
                        ? Total_amt
                        : 0
                      ).toFixed(2)}
                    </strong>
                  </span>
                </div>

                {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <label style={{ width: '140px', textAlign: 'left', color: 'darkblue' }}><strong>Total amt:</strong></label>
                  <span style={{ minWidth: '80px', textAlign: 'right' }}>
                    <strong>
                      {formMode === 'view' ?
                        `${Freight_amt} + ${Insurance_amt} + ${Oth_amt} = ${Total_amt}`
                        : Total_amt}
                    </strong>
                  </span>
                </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PurchaseOrder;
